import { useState, useEffect, useCallback } from "react";

// ===== CONFIG — แก้ IP ตรงนี้ =====
const API = "/api";
// ถ้า frontend อยู่บน server เดียวกันใช้: const API = "/api";
// ===================================

// ===== API HELPER =====
async function apiFetch(path, options = {}) {
  const res = await fetch(`${API}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "เกิดข้อผิดพลาด");
  return data;
}

// ===== STYLES =====
const globalStyle = `
  @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;600;700&family=Noto+Serif+Thai:wght@400;600;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: 'Sarabun', sans-serif; background: #f0f4f8; min-height: 100vh; }
  :root {
    --primary: #1a3a6b; --primary-light: #2451a0;
    --accent: #c8972a; --accent-light: #e8b84b;
    --success: #1a7a4a; --danger: #b02020; --warning: #c87020;
    --bg: #f0f4f8; --surface: #ffffff; --border: #d0d8e8;
    --text: #1a2233; --text-muted: #5a6880;
    --radius: 10px;
    --shadow: 0 2px 12px rgba(26,58,107,0.10);
    --shadow-lg: 0 8px 32px rgba(26,58,107,0.15);
  }
  .app-wrap { min-height: 100vh; background: linear-gradient(135deg, #e8eef8 0%, #f5f0e8 100%); }
  .site-header { background: var(--primary); color: white; padding: 0; box-shadow: 0 2px 12px rgba(0,0,0,0.18); position: sticky; top: 0; z-index: 100; }
  .header-inner { max-width: 1100px; margin: 0 auto; padding: 10px 14px; display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  .school-logo { width: 42px; height: 42px; background: var(--accent); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 18px; font-weight: 700; color: white; flex-shrink: 0; box-shadow: 0 2px 8px rgba(0,0,0,0.2); }
  .school-title h1 { font-family: 'Noto Serif Thai', serif; font-size: 15px; font-weight: 700; line-height: 1.2; }
  .school-title p { font-size: 11px; opacity: 0.75; margin-top: 1px; }
  .header-right { margin-left: auto; display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
  .user-chip { background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.25); border-radius: 20px; padding: 4px 10px; font-size: 12px; color: white; white-space: nowrap; }
  .btn-logout { background: rgba(255,255,255,0.12); border: 1px solid rgba(255,255,255,0.3); color: white; padding: 5px 12px; border-radius: 20px; cursor: pointer; font-size: 12px; font-family: 'Sarabun', sans-serif; transition: background 0.2s; white-space: nowrap; }
  .btn-logout:hover { background: rgba(255,255,255,0.22); }
  .btn-regulation { background: rgba(200,151,42,0.25); border: 1px solid rgba(200,151,42,0.6); color: white; padding: 5px 12px; border-radius: 20px; cursor: pointer; font-size: 12px; font-family: 'Sarabun', sans-serif; transition: background 0.2s; white-space: nowrap; display: inline-flex; align-items: center; gap: 5px; }
  .btn-regulation:hover { background: rgba(200,151,42,0.45); }
  @media(max-width: 600px) {
    .header-inner { padding: 8px 12px; gap: 8px; }
    .school-logo { width: 36px; height: 36px; font-size: 15px; }
    .school-title h1 { font-size: 13px; }
    .school-title p { display: none; }
    .header-right { width: 100%; margin-left: 0; justify-content: flex-end; padding-bottom: 4px; }
    .user-chip { font-size: 11px; padding: 3px 8px; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .btn-logout { font-size: 11px; padding: 4px 10px; }
    .btn-regulation { font-size: 11px; padding: 4px 10px; }
    .stats-grid { grid-template-columns: repeat(2,1fr) !important; }
    .main-content { padding: 14px 10px 50px; }
    .card-body { padding: 14px; }
    .modal-box { max-height: 95vh; border-radius: 10px; }
    .modal-body { padding: 14px 14px 16px; }
    .modal-footer { padding: 10px 14px; flex-wrap: wrap; }
    .info-grid { grid-template-columns: 1fr; }
    .admin-nav-btn { padding: 9px 12px; font-size: 13px; }
  }
  .main-content { max-width: 900px; margin: 0 auto; padding: 28px 16px 60px; }
  .card { background: var(--surface); border-radius: var(--radius); border: 1px solid var(--border); box-shadow: var(--shadow); overflow: hidden; }
  .card-header { background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%); color: white; padding: 16px 22px; display: flex; align-items: center; gap: 10px; }
  .card-header h2 { font-family: 'Noto Serif Thai', serif; font-size: 17px; font-weight: 600; }
  .card-body { padding: 22px; }
  .section-title { font-family: 'Noto Serif Thai', serif; font-size: 15px; font-weight: 600; color: var(--primary); border-left: 4px solid var(--accent); padding-left: 10px; margin: 22px 0 14px; }
  .section-title:first-child { margin-top: 0; }
  .form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px 16px; }
  .form-grid.cols-3 { grid-template-columns: 1fr 1fr 1fr; }
  .form-grid.cols-1 { grid-template-columns: 1fr; }
  @media(max-width:600px){ .form-grid, .form-grid.cols-3 { grid-template-columns: 1fr; } }
  .form-group { display: flex; flex-direction: column; gap: 4px; }
  .form-group.span-2 { grid-column: span 2; }
  @media(max-width:600px){ .form-group.span-2 { grid-column: span 1; } }
  label { font-size: 13px; font-weight: 500; color: var(--text-muted); }
  label .req { color: var(--danger); margin-left: 2px; }
  input, select, textarea { font-family: 'Sarabun', sans-serif; font-size: 14px; border: 1.5px solid var(--border); border-radius: 7px; padding: 8px 11px; color: var(--text); background: #f8fafc; transition: border-color 0.2s, box-shadow 0.2s; width: 100%; }
  input:focus, select:focus, textarea:focus { outline: none; border-color: var(--primary-light); box-shadow: 0 0 0 3px rgba(36,81,160,0.10); background: white; }
  input:disabled, select:disabled { background: #eef1f6; color: var(--text-muted); cursor: not-allowed; }
  input[type="file"] { padding: 6px; cursor: pointer; }
  .btn { font-family: 'Sarabun', sans-serif; font-size: 14px; font-weight: 600; border: none; border-radius: 8px; padding: 10px 22px; cursor: pointer; transition: all 0.2s; display: inline-flex; align-items: center; gap: 6px; }
  .btn-primary { background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%); color: white; box-shadow: 0 2px 8px rgba(26,58,107,0.20); }
  .btn-primary:hover { opacity: 0.92; transform: translateY(-1px); }
  .btn-accent { background: linear-gradient(90deg, var(--accent) 0%, var(--accent-light) 100%); color: white; box-shadow: 0 2px 8px rgba(200,151,42,0.20); }
  .btn-accent:hover { opacity: 0.92; transform: translateY(-1px); }
  .btn-success { background: var(--success); color: white; }
  .btn-danger { background: var(--danger); color: white; }
  .btn-outline { background: white; border: 1.5px solid var(--border); color: var(--text); }
  .btn-outline:hover { border-color: var(--primary-light); color: var(--primary); }
  .btn-sm { padding: 6px 14px; font-size: 13px; }
  .btn:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
  .badge { display: inline-flex; align-items: center; gap: 5px; padding: 4px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; }
  .badge-waiting { background: #fff3e0; color: var(--warning); border: 1px solid #ffe0b2; }
  .badge-review { background: #e3f0ff; color: var(--primary); border: 1px solid #b3d1ff; }
  .badge-approved { background: #e6f4ed; color: var(--success); border: 1px solid #a8d5be; }
  .badge-rejected { background: #fdecea; color: var(--danger); border: 1px solid #f5c6c6; }
  .login-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #1a3a6b 0%, #2451a0 60%, #1a3a6b 100%); padding: 20px; }
  .login-box { background: white; border-radius: 16px; box-shadow: 0 16px 48px rgba(0,0,0,0.25); width: 100%; max-width: 420px; overflow: hidden; }
  .login-header { background: linear-gradient(135deg, var(--primary) 0%, var(--primary-light) 100%); padding: 28px 28px 24px; text-align: center; color: white; }
  .login-logo { width: 72px; height: 72px; background: rgba(255,255,255,0.15); border: 3px solid rgba(255,255,255,0.35); border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 28px; margin: 0 auto 14px; }
  .login-header h2 { font-family: 'Noto Serif Thai', serif; font-size: 19px; margin-bottom: 4px; }
  .login-header p { font-size: 13px; opacity: 0.75; }
  .login-body { padding: 26px 28px 28px; }
  .login-tabs { display: flex; gap: 0; border: 1.5px solid var(--border); border-radius: 8px; overflow: hidden; margin-bottom: 20px; }
  .login-tab { flex: 1; padding: 9px; text-align: center; font-size: 13px; font-weight: 500; cursor: pointer; background: #f8fafc; color: var(--text-muted); border: none; font-family: 'Sarabun', sans-serif; transition: all 0.2s; }
  .login-tab.active { background: var(--primary); color: white; font-weight: 600; }
  .login-hint { background: #f0f4f8; border-radius: 7px; padding: 10px 14px; font-size: 12px; color: var(--text-muted); margin-bottom: 16px; border-left: 3px solid var(--accent); }
  .error-msg { background: #fdecea; border: 1px solid #f5c6c6; color: var(--danger); border-radius: 7px; padding: 9px 14px; font-size: 13px; margin-bottom: 14px; }
  .alert { border-radius: 8px; padding: 12px 16px; font-size: 13px; margin-bottom: 16px; display: flex; align-items: flex-start; gap: 8px; }
  .alert-info { background: #e3f0ff; color: var(--primary); border: 1px solid #b3d1ff; }
  .alert-success { background: #e6f4ed; color: var(--success); border: 1px solid #a8d5be; }
  .alert-warning { background: #fff3e0; color: var(--warning); border: 1px solid #ffe0b2; }
  .alert-danger { background: #fdecea; color: var(--danger); border: 1px solid #f5c6c6; }
  .table-wrap { overflow-x: auto; border-radius: 8px; border: 1px solid var(--border); }
  table { width: 100%; border-collapse: collapse; font-size: 13px; }
  th { background: #f0f4f8; color: var(--text); font-weight: 600; padding: 10px 14px; text-align: left; border-bottom: 1.5px solid var(--border); white-space: nowrap; }
  td { padding: 10px 14px; border-bottom: 1px solid #edf0f5; vertical-align: middle; }
  tr:last-child td { border-bottom: none; }
  tr:hover td { background: #f8fafc; }
  .plan-rows { display: flex; flex-direction: column; gap: 8px; }
  .plan-row { display: grid; grid-template-columns: auto 1fr; gap: 10px; align-items: center; background: #f8fafc; border: 1.5px solid var(--border); border-radius: 8px; padding: 10px 14px; transition: border-color 0.2s; }
  .plan-row.selected { border-color: var(--primary-light); background: #eef3fc; }
  .plan-rank { font-size: 13px; font-weight: 600; color: var(--text-muted); min-width: 60px; }
  .upload-card { border: 2px dashed var(--border); border-radius: 9px; padding: 14px 16px; background: #f8fafc; transition: border-color 0.2s; }
  .upload-card:hover { border-color: var(--primary-light); }
  .upload-label { font-size: 13px; font-weight: 500; color: var(--text); margin-bottom: 6px; display: block; }
  .upload-hint { font-size: 11px; color: var(--text-muted); margin-top: 3px; }
  .uploaded-file { font-size: 12px; color: var(--success); margin-top: 4px; display: flex; align-items: center; gap: 4px; }
  .admin-nav { display: flex; gap: 0; border-bottom: 2px solid var(--border); margin-bottom: 22px; overflow-x: auto; }
  .admin-nav-btn { padding: 11px 20px; font-size: 14px; font-weight: 500; font-family: 'Sarabun', sans-serif; background: none; border: none; color: var(--text-muted); cursor: pointer; border-bottom: 3px solid transparent; margin-bottom: -2px; transition: all 0.2s; white-space: nowrap; }
  .admin-nav-btn.active { color: var(--primary); font-weight: 700; border-bottom-color: var(--primary); }
  .admin-nav-btn:hover { color: var(--primary); }
  .modal-bg { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 200; display: flex; align-items: center; justify-content: center; padding: 16px; }
  .modal-box { background: white; border-radius: 14px; box-shadow: 0 20px 60px rgba(0,0,0,0.25); width: 100%; max-width: 700px; max-height: 90vh; overflow-y: auto; }
  .modal-header { background: linear-gradient(90deg, var(--primary) 0%, var(--primary-light) 100%); color: white; padding: 16px 22px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; }
  .modal-header h3 { font-size: 16px; font-weight: 600; }
  .modal-close { background: rgba(255,255,255,0.15); border: none; color: white; width: 30px; height: 30px; border-radius: 50%; font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
  .modal-body { padding: 20px 22px 22px; }
  .modal-footer { padding: 14px 22px; border-top: 1px solid var(--border); display: flex; justify-content: flex-end; gap: 10px; flex-wrap: wrap; }
  .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 6px 16px; }
  .info-row { display: flex; flex-direction: column; gap: 2px; padding: 6px 0; }
  .info-label { font-size: 11px; color: var(--text-muted); text-transform: uppercase; letter-spacing: 0.5px; }
  .info-value { font-size: 14px; color: var(--text); font-weight: 500; }
  .page-title { display: flex; align-items: center; gap: 10px; margin-bottom: 20px; }
  .page-title h2 { font-family: 'Noto Serif Thai', serif; font-size: 20px; font-weight: 700; color: var(--primary); }
  .page-title .subtitle { font-size: 13px; color: var(--text-muted); margin-top: 1px; }
  .status-banner { border-radius: 10px; padding: 18px 20px; margin-bottom: 20px; }
  .status-banner.waiting { background: #fff8e6; border: 1.5px solid #ffd580; }
  .status-banner.approved { background: #e8f5ee; border: 1.5px solid #6ec49a; }
  .status-banner.rejected { background: #fdf0f0; border: 1.5px solid #e8a0a0; }
  .exam-info { margin-top: 12px; display: flex; gap: 20px; flex-wrap: wrap; }
  .exam-info-item .lbl { font-size: 11px; color: var(--text-muted); }
  .exam-info-item .val { font-size: 22px; font-weight: 700; color: var(--primary); }
  .divider { border: none; border-top: 1.5px solid var(--border); margin: 18px 0; }
  .flex { display: flex; } .gap-2 { gap: 8px; } .gap-3 { gap: 12px; }
  .justify-end { justify-content: flex-end; } .justify-between { justify-content: space-between; }
  .mt-2 { margin-top: 8px; } .mt-3 { margin-top: 14px; } .mt-4 { margin-top: 20px; }
  .text-sm { font-size: 13px; } .text-xs { font-size: 11px; } .text-muted { color: var(--text-muted); } .w-full { width: 100%; }
  .spinner { display: inline-block; width: 18px; height: 18px; border: 2px solid rgba(255,255,255,0.4); border-top-color: white; border-radius: 50%; animation: spin 0.7s linear infinite; }
  @keyframes spin { to { transform: rotate(360deg); } }
  .loading-screen { min-height: 100vh; display: flex; align-items: center; justify-content: center; }
  .loading-box { text-align: center; color: var(--text-muted); }
  .loading-spinner { width: 40px; height: 40px; border: 3px solid var(--border); border-top-color: var(--primary); border-radius: 50%; animation: spin 0.8s linear infinite; margin: 0 auto 14px; }
`;

// ===== CONSTANTS =====
const PLANS = [
  "วิทยาศาสตร์-คณิตศาสตร์",
  "ศิลป์-คณิตศาสตร์",
  "ศิลป์-สังคมศึกษา",
  "ศิลป์-ภาษาจีน",
  "ศิลป์-ภาษาอังกฤษ-ญี่ปุ่น/เกาหลี",
];
const RELIGIONS = ["พุทธ", "คริสต์", "อิสลาม", "ฮินดู", "อื่นๆ"];
const BLOOD_GROUPS = ["A", "B", "AB", "O", "ไม่ระบุ"];
const PREFIXES = ["เด็กหญิง", "เด็กชาย", "นาย", "นางสาว"];

function StatusBadge({ status }) {
  if (status === "draft") return <span className="badge badge-waiting">⏳ ยังไม่ส่งข้อมูล</span>;
  if (status === "pending") return <span className="badge badge-review">📋 รอการตรวจสอบ</span>;
  if (status === "approved") return <span className="badge badge-approved">✅ ผ่านการตรวจสอบ</span>;
  if (status === "rejected") return <span className="badge badge-rejected">🔄 ส่งกลับแก้ไข</span>;
  return null;
}

// ===== THAI DATE PICKER =====
const THAI_MONTHS = [
  "มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน",
  "กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"
];

// แปลง "YYYY-MM-DD" (ค.ศ.) → { day, month, year } (พ.ศ.)
function isoToParts(iso) {
  if (!iso) return { day: "", month: "", year: "" };
  const [y, m, d] = iso.split("-");
  return { day: String(parseInt(d)), month: String(parseInt(m)), year: String(parseInt(y) + 543) };
}

// แปลง { day, month, year (พ.ศ.) } → "YYYY-MM-DD" (ค.ศ.)
function partsToIso({ day, month, year }) {
  if (!day || !month || !year || year.length < 4) return "";
  const yAD = parseInt(year) - 543;
  return `${yAD}-${String(month).padStart(2,"0")}-${String(day).padStart(2,"0")}`;
}

function ThaiDatePicker({ value, onChange, disabled }) {
  const parts = isoToParts(value);
  const [day, setDay] = useState(parts.day);
  const [month, setMonth] = useState(parts.month);
  const [year, setYear] = useState(parts.year);

  // sync ถ้า value เปลี่ยนจากภายนอก (เช่น ตอนโหลดข้อมูล)
  useEffect(() => {
    const p = isoToParts(value);
    setDay(p.day); setMonth(p.month); setYear(p.year);
  }, [value]);

  const update = (d, m, y) => {
    const iso = partsToIso({ day: d, month: m, year: y });
    if (iso) onChange(iso);
  };

  const daysInMonth = (m, y) => {
    if (!m || !y || y.length < 4) return 31;
    const yAD = parseInt(y) - 543;
    return new Date(yAD, parseInt(m), 0).getDate();
  };

  const maxDay = daysInMonth(month, year);
  const days = Array.from({ length: maxDay }, (_, i) => i + 1);

  // ปีปัจจุบัน พ.ศ. ถึงย้อนหลัง 30 ปี (สำหรับนักเรียน ม.1-ม.4)
  const currentYearBE = new Date().getFullYear() + 543;
  const years = Array.from({ length: 30 }, (_, i) => currentYearBE - i);

  const selStyle = {
    fontFamily: "'Sarabun', sans-serif", fontSize: 14,
    border: "1.5px solid var(--border)", borderRadius: 7,
    padding: "8px 6px", color: "var(--text)", background: disabled ? "#eef1f6" : "#f8fafc",
    cursor: disabled ? "not-allowed" : "pointer",
    flex: 1, minWidth: 0,
  };

  return (
    <div style={{ display: "flex", gap: 6 }}>
      {/* วัน */}
      <select value={day} disabled={disabled} style={{ ...selStyle, maxWidth: 72 }}
        onChange={e => { setDay(e.target.value); update(e.target.value, month, year); }}>
        <option value="">วัน</option>
        {days.map(d => <option key={d} value={d}>{d}</option>)}
      </select>
      {/* เดือน */}
      <select value={month} disabled={disabled} style={{ ...selStyle, maxWidth: 150 }}
        onChange={e => { setMonth(e.target.value); update(day, e.target.value, year); }}>
        <option value="">เดือน</option>
        {THAI_MONTHS.map((m, i) => <option key={i+1} value={i+1}>{m}</option>)}
      </select>
      {/* ปี พ.ศ. */}
      <select value={year} disabled={disabled} style={{ ...selStyle, maxWidth: 90 }}
        onChange={e => { setYear(e.target.value); update(day, month, e.target.value); }}>
        <option value="">ปี พ.ศ.</option>
        {years.map(y => <option key={y} value={y}>{y}</option>)}
      </select>
    </div>
  );
}


const DOC_LABELS = {
  photo: "รูปถ่ายสวมชุดนักเรียน",
  pp1front: "ปพ.1 / ปพ.6 / ปพ.7 (ด้านหน้า)",
  pp1back: "ปพ.1 / ปพ.6 / ปพ.7 (ด้านหลัง)",
  housebook: "สำเนาทะเบียนบ้าน",
};

// ===== DOC PREVIEW BUTTON (inline modal) =====
function DocPreviewButton({ url, name, isPdf }) {
  const [show, setShow] = useState(false);
  return (
    <>
      <button className="btn btn-outline btn-sm" onClick={() => setShow(true)}>👁️ ดูไฟล์</button>
      {show && (
        <div className="modal-bg" style={{ zIndex: 400 }} onClick={e => e.target === e.currentTarget && setShow(false)}>
          <div className="modal-box" style={{ maxWidth: 860 }}>
            <div className="modal-header">
              <h3>📎 {name}</h3>
              <div style={{ display: "flex", gap: 8 }}>
                <a href={`${url}/download`} style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: "white", padding: "5px 12px", borderRadius: 6, fontSize: 12, textDecoration: "none" }}>⬇️ ดาวน์โหลด</a>
                <button className="modal-close" onClick={() => setShow(false)}>×</button>
              </div>
            </div>
            <div style={{ padding: 16, background: "#1a1a2e", minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {isPdf
                ? <iframe src={url} title={name} style={{ width: "100%", height: "70vh", border: "none", borderRadius: 6 }} />
                : <img src={url} alt={name} style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 6, boxShadow: "0 4px 20px rgba(0,0,0,0.4)" }} />
              }
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// ===== DOC VIEWER COMPONENT =====
function DocViewer({ docs }) {
  const [preview, setPreview] = useState(null);
  const isPdf = (name) => name && name.toLowerCase().endsWith(".pdf");

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {Object.entries(docs).map(([key, fileObj]) => {
          const label = DOC_LABELS[key] || key;
          const hasFile = fileObj && fileObj.url;
          return (
            <div key={key} style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "10px 14px", borderRadius: 8,
              background: hasFile ? "#f0faf4" : "#fafafa",
              border: `1.5px solid ${hasFile ? "#a8d5be" : "#e0e0e0"}`,
              gap: 10, flexWrap: "wrap",
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 18 }}>{hasFile ? (isPdf(fileObj.name) ? "📄" : "🖼️") : "❌"}</span>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600, color: hasFile ? "var(--success)" : "var(--text-muted)" }}>{label}</div>
                  {hasFile
                    ? <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{fileObj.name}</div>
                    : <div style={{ fontSize: 11, color: "var(--text-muted)" }}>ยังไม่ได้อัพโหลด</div>
                  }
                </div>
              </div>
              {hasFile && (
                <button className="btn btn-outline btn-sm" onClick={() => setPreview({ label, name: fileObj.name, url: fileObj.url })}>
                  👁️ ดูไฟล์
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* Preview Modal */}
      {preview && (
        <div className="modal-bg" style={{ zIndex: 400 }} onClick={e => e.target === e.currentTarget && setPreview(null)}>
          <div className="modal-box" style={{ maxWidth: 860 }}>
            <div className="modal-header">
              <h3>📎 {preview.label} — {preview.name}</h3>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <a href={`${preview.url}/download`}
                  style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: "white", padding: "5px 12px", borderRadius: 6, fontSize: 12, textDecoration: "none" }}>
                  ⬇️ ดาวน์โหลด
                </a>
                <button className="modal-close" onClick={() => setPreview(null)}>×</button>
              </div>
            </div>
            <div style={{ padding: 16, background: "#1a1a2e", minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {isPdf(preview.name)
                ? <iframe src={preview.url} title={preview.label} style={{ width: "100%", height: "70vh", border: "none", borderRadius: 6 }} />
                : <img src={preview.url} alt={preview.label} style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 6, boxShadow: "0 4px 20px rgba(0,0,0,0.4)" }} />
              }
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// ===== UPLOAD FILE (multipart) =====
async function uploadFile(idCard, fieldName, file) {
  if (file.size > 10 * 1024 * 1024) throw new Error("ไฟล์ขนาดเกิน 10 MB");
  const formData = new FormData();
  formData.append(fieldName, file);
  const res = await fetch(`${API}/files/${idCard}`, { method: "POST", body: formData });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "อัพโหลดไม่สำเร็จ");
  return data.files[fieldName]; // { name, url }
}

// ===== LOGIN =====
function LoginPage({ onLogin }) {
  const [tab, setTab] = useState("applicant");
  const [id, setId] = useState("");
  const [adminUser, setAdminUser] = useState("");
  const [adminPass, setAdminPass] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleApplicantLogin = async () => {
    setError(""); setLoading(true);
    try {
      const res = await apiFetch("/auth/applicant", {
        method: "POST", body: { idCard: id.trim() },
      });
      onLogin({ role: "applicant", data: res.data });
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  const handleAdminLogin = async () => {
    setError(""); setLoading(true);
    try {
      const res = await apiFetch("/auth/admin", {
        method: "POST", body: { username: adminUser, password: adminPass },
      });
      onLogin({ role: "admin", data: res.data });
    } catch (e) { setError(e.message); }
    setLoading(false);
  };

  return (
    <div className="login-wrap">
      <div className="login-box">
        <div className="login-header">
          <div className="login-logo">🏫</div>
          <h2>โรงเรียนหล่มสักวิทยาคม</h2>
          <p>ระบบรับสมัครนักเรียน ปีการศึกษา 2569</p>
        </div>
        <div className="login-body">
          <div className="login-tabs">
            <button className={`login-tab ${tab === "applicant" ? "active" : ""}`} onClick={() => { setTab("applicant"); setError(""); }}>👤 ผู้สมัคร</button>
            <button className={`login-tab ${tab === "admin" ? "active" : ""}`} onClick={() => { setTab("admin"); setError(""); }}>🔐 เจ้าหน้าที่</button>
          </div>
          {error && <div className="error-msg">⚠️ {error}</div>}
          {tab === "applicant" && (
            <>
              <div className="login-hint">กรอกเลขประจำตัวประชาชน 13 หลัก ที่ได้แจ้งไว้กับเจ้าหน้าที่</div>
              <div className="form-group" style={{ marginBottom: 16 }}>
                <label>เลขประจำตัวประชาชน</label>
                <input value={id} onChange={e => setId(e.target.value)} placeholder="X-XXXX-XXXXX-XX-X" maxLength={13} onKeyDown={e => e.key === "Enter" && handleApplicantLogin()} />
              </div>
              <button className="btn btn-primary w-full" style={{ justifyContent: "center" }} onClick={handleApplicantLogin} disabled={loading}>
                {loading ? <span className="spinner" /> : "เข้าสู่ระบบ →"}
              </button>
            </>
          )}
          {tab === "admin" && (
            <>
              <div className="form-group" style={{ marginBottom: 12 }}>
                <label>ชื่อผู้ใช้</label>
                <input value={adminUser} onChange={e => setAdminUser(e.target.value)} placeholder="admin" />
              </div>
              <div className="form-group" style={{ marginBottom: 16 }}>
                <label>รหัสผ่าน</label>
                <input type="password" value={adminPass} onChange={e => setAdminPass(e.target.value)} placeholder="••••••••" onKeyDown={e => e.key === "Enter" && handleAdminLogin()} />
              </div>
              <button className="btn btn-primary w-full" style={{ justifyContent: "center" }} onClick={handleAdminLogin} disabled={loading}>
                {loading ? <span className="spinner" /> : "เข้าสู่ระบบเจ้าหน้าที่ →"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

// ===== PRINT ADMISSION CARD =====
function printAdmissionCard({ form, examNo, examRoom, serviceArea, level }) {
  const { prefix, firstName, lastName, docs } = form;
  const photoUrl = docs?.photo?.url || "";
  const isM1 = level === "ม.1";
  const levelNum = isM1 ? "1" : "4";

  const html = `<!DOCTYPE html>
<html lang="th">
<head>
  <meta charset="UTF-8">
  <title>บัตรประจำตัวผู้สมัคร</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;600;700&family=Noto+Serif+Thai:wght@600;700;800&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      font-family: 'Sarabun', sans-serif;
      background: #eef2f7;
      display: flex; justify-content: center; align-items: center;
      min-height: 100vh; padding: 30px;
    }
    .card {
      width: 210mm;
      border: 3px solid #1a3a6b;
      border-radius: 14px;
      overflow: hidden;
      box-shadow: 0 8px 32px rgba(26,58,107,0.18);
      background: white;
    }
    /* HEADER */
    .card-header {
      background: linear-gradient(135deg, #1a3a6b 0%, #2451a0 100%);
      color: white;
      padding: 20px 24px 18px;
      display: flex; align-items: center; gap: 18px;
    }
    .logo {
      width: 72px; height: 72px; border-radius: 50%;
      border: 3px solid rgba(255,255,255,0.6);
      object-fit: contain; background: white; flex-shrink: 0;
    }
    .header-text { flex: 1; }
    .header-label {
      font-size: 11px; font-weight: 500; letter-spacing: 1.5px;
      opacity: 0.75; text-transform: uppercase; margin-bottom: 4px;
    }
    .header-text h1 {
      font-family: 'Noto Serif Thai', serif;
      font-size: 17px; font-weight: 800; line-height: 1.5;
    }
    .header-text p { font-size: 13px; opacity: 0.8; margin-top: 4px; }
    .header-badges { display: flex; gap: 8px; margin-top: 8px; flex-wrap: wrap; }
    .badge {
      background: rgba(255,255,255,0.18); border: 1px solid rgba(255,255,255,0.4);
      border-radius: 20px; padding: 3px 14px; font-size: 12px; font-weight: 500;
    }
    .badge-online { background: rgba(200,151,42,0.35); border-color: rgba(200,151,42,0.7); }
    /* BODY */
    .card-body { padding: 24px 28px; display: flex; gap: 24px; align-items: flex-start; }
    .photo-box {
      width: 100px; flex-shrink: 0;
      border: 2px solid #d0d8e8; border-radius: 8px;
      overflow: hidden; aspect-ratio: 3/4; background: #f0f4f8;
      display: flex; align-items: center; justify-content: center;
    }
    .photo-box img { width: 100%; height: 100%; object-fit: cover; }
    .photo-placeholder { font-size: 11px; color: #aaa; text-align: center; padding: 10px; line-height: 1.6; }
    .info { flex: 1; }
    .name {
      font-family: 'Noto Serif Thai', serif;
      font-size: 22px; font-weight: 700; color: #1a2233;
      margin-bottom: 14px; line-height: 1.4;
      border-bottom: 2px solid #e8eef8; padding-bottom: 12px;
    }
    .info-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 14px 20px; }
    .info-item { }
    .info-label { font-size: 11px; color: #5a6880; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 3px; }
    .info-value { font-size: 20px; font-weight: 700; color: #1a3a6b; }
    /* FOOTER */
    .card-footer {
      background: linear-gradient(90deg, #f0f4f8 0%, #e8eef8 100%);
      border-top: 2px solid #d0d8e8;
      padding: 12px 28px;
      display: flex; justify-content: space-between; align-items: center;
    }
    .footer-left { font-size: 12px; color: #5a6880; }
    .footer-right { font-size: 12px; color: #1a3a6b; font-weight: 600; }
    @media print {
      body { padding: 0; background: white; min-height: auto; }
      .card { box-shadow: none; border-radius: 0; width: 100%; }
    }
  </style>
</head>
<body>
  <div class="card">
    <div class="card-header">
      <img class="logo" src="https://lomsak.ac.th/schlogo.png" alt="โลโก้" onerror="this.style.display='none'" />
      <div class="header-text">
        <div class="header-label">บัตรประจำตัวผู้สมัคร</div>
        <h1>เข้าเรียนชั้นมัธยมศึกษาปีที่ ${levelNum}<br>ปีการศึกษา 2569 ประเภทห้องเรียนปกติ</h1>
        <p>โรงเรียนหล่มสักวิทยาคม อำเภอหล่มสัก จังหวัดเพชรบูรณ์</p>
        <div class="header-badges">
          <span class="badge badge-online">🌐 สมัครออนไลน์</span>
          ${isM1 && serviceArea ? `<span class="badge">${serviceArea}</span>` : ""}
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="photo-box">
        ${photoUrl
          ? `<img src="${photoUrl}" alt="รูปถ่าย" crossorigin="anonymous" />`
          : `<div class="photo-placeholder">📷<br>รูปถ่าย</div>`
        }
      </div>
      <div class="info">
        <div class="name">${prefix}${firstName} ${lastName}</div>
        <div class="info-grid">
          <div class="info-item">
            <div class="info-label">เลขที่นั่งสอบ</div>
            <div class="info-value">${examNo || "-"}</div>
          </div>
          <div class="info-item">
            <div class="info-label">ห้องสอบ</div>
            <div class="info-value">${examRoom || "-"}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <span class="footer-left">⚠️ กรุณานำบัตรนี้มาแสดงในวันสอบ</span>
      <span class="footer-right">โรงเรียนหล่มสักวิทยาคม</span>
    </div>
  </div>
  <script>window.onload = () => { window.print(); }</script>
</body>
</html>`;

  const win = window.open("", "_blank");
  win.document.write(html);
  win.document.close();
}

// ===== APPLICATION FORM =====
function ApplicationForm({ user, onLogout }) {
  const applicant = user.data;
  const isM4 = applicant.level === "ม.4";

  const emptyForm = {
    prefix: "", firstName: "", lastName: "", birthDate: "", religion: "",
    idCard: applicant.idCard, bloodGroup: "",
    houseNo: "", moo: "", subdistrict: "", road: "", district: "", province: "", postalCode: "", phone: "",
    fromSchool: "", gpa: "", schoolSubdistrict: "", schoolDistrict: "", schoolProvince: "",
    fatherName: "", fatherPhone: "", fatherOccupation: "", motherName: "", motherPhone: "", motherOccupation: "", guardianName: "", guardianPhone: "", guardianOccupation: "",
    planPriority: ["", "", "", "", ""],
    docs: { photo: null, pp1front: null, pp1back: null, housebook: null },
  };

  const [form, setForm] = useState(emptyForm);
  const [status, setStatus] = useState("draft");
  const [examNo, setExamNo] = useState("");
  const [examRoom, setExamRoom] = useState("");
  const [serviceArea, setServiceArea] = useState("");
  const [remark, setRemark] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMsg, setSuccessMsg] = useState("");
  const [showRegulation, setShowRegulation] = useState(false);

  // โหลดข้อมูลและ poll สถานะอัตโนมัติทุก 15 วินาที
  useEffect(() => {
    let isFirst = true;

    const fetchStatus = () => {
      apiFetch(`/applications/${applicant.idCard}`)
        .then(data => {
          if (data) {
            // ถ้า status เปลี่ยน หรือโหลดครั้งแรก — อัพเดทข้อมูล
            setStatus(prev => {
              if (prev !== data.status || isFirst) {
                setForm(data.form);
                setExamNo(data.examNo || "");
                setExamRoom(data.examRoom || "");
                setServiceArea(data.serviceArea || "");
                setRemark(data.remark || "");
              }
              return data.status;
            });
          }
        })
        .catch(console.error)
        .finally(() => {
          if (isFirst) { setLoading(false); isFirst = false; }
        });
    };

    fetchStatus();
    const interval = setInterval(fetchStatus, 15000);
    return () => clearInterval(interval);
  }, [applicant.idCard]);

  const set = (field, val) => setForm(f => ({ ...f, [field]: val }));
  const setPlan = (idx, val) => {
    const arr = [...form.planPriority];
    arr[idx] = val;
    setForm(f => ({ ...f, planPriority: arr }));
  };
  const [uploadingDoc, setUploadingDoc] = useState({});
  const setDoc = async (field, file) => {
    if (!file) return;
    setUploadingDoc(u => ({ ...u, [field]: true }));
    try {
      const result = await uploadFile(applicant.idCard, field, file);
      setForm(f => ({ ...f, docs: { ...f.docs, [field]: result } }));
    } catch (e) { alert(e.message); }
    setUploadingDoc(u => ({ ...u, [field]: false }));
  };

  const locked = status === "pending" || status === "approved";

  const validate = () => {
    const e = {};
    if (!form.prefix) e.prefix = "กรุณาเลือกคำนำหน้า";
    if (!form.firstName.trim()) e.firstName = "กรุณากรอกชื่อ";
    if (!form.lastName.trim()) e.lastName = "กรุณากรอกนามสกุล";
    if (!form.birthDate) e.birthDate = "กรุณาเลือกวันเกิด";
    if (!form.religion) e.religion = "กรุณาเลือกศาสนา";
    if (!form.bloodGroup) e.bloodGroup = "กรุณาเลือกกลุ่มเลือด";
    if (!form.houseNo.trim()) e.houseNo = "กรุณากรอกบ้านเลขที่";
    if (!form.subdistrict.trim()) e.subdistrict = "กรุณากรอกตำบล";
    if (!form.district.trim()) e.district = "กรุณากรอกอำเภอ";
    if (!form.province.trim()) e.province = "กรุณากรอกจังหวัด";
    if (!form.phone.trim()) e.phone = "กรุณากรอกเบอร์โทรศัพท์";
    if (!form.fromSchool.trim()) e.fromSchool = "กรุณากรอกชื่อโรงเรียน";
    if (isM4 && !form.gpa.trim()) e.gpa = "กรุณากรอกเกรดเฉลี่ย";
    if (isM4) {
      const selected = form.planPriority.filter(p => p !== "");
      if (selected.length === 0) e.plan = "กรุณาเลือกแผนการเรียนอย่างน้อย 1 ลำดับ";
      if (new Set(selected).size !== selected.length) e.plan = "ไม่สามารถเลือกแผนการเรียนซ้ำกันได้";
    }
    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    setErrors(e);
    if (Object.keys(e).length > 0) { alert("กรุณากรอกข้อมูลที่จำเป็นให้ครบถ้วน"); return; }
    setSaving(true);
    try {
      await apiFetch("/applications", {
        method: "POST",
        body: { idCard: applicant.idCard, level: applicant.level, form },
      });
      setStatus("pending");
      setSuccessMsg("ส่งข้อมูลสำเร็จ! กรุณารอเจ้าหน้าที่ตรวจสอบ");
    } catch (e) { alert("เกิดข้อผิดพลาด: " + e.message); }
    setSaving(false);
  };

  if (loading) return (
    <div className="app-wrap">
      <style>{globalStyle}</style>
      <div className="loading-screen"><div className="loading-box"><div className="loading-spinner" /><p>กำลังโหลดข้อมูล...</p></div></div>
    </div>
  );

  const doc1Label = "สำเนา ปพ.1 ปีการศึกษา 2568 (ด้านหน้า)" + (!isM4 ? " — หากไม่มีใช้ ปพ.6/ปพ.7" : "");
  const doc2Label = "สำเนา ปพ.1 ปีการศึกษา 2568 (ด้านหลัง)" + (!isM4 ? " — หากไม่มีใช้ ปพ.6/ปพ.7" : "");

  return (
    <div className="app-wrap">
      <style>{globalStyle}</style>
      <header className="site-header">
        <div className="header-inner">
          <div className="school-logo">ห</div>
          <div className="school-title"><h1>โรงเรียนหล่มสักวิทยาคม</h1><p>ระบบรับสมัครนักเรียน ปีการศึกษา 2569</p></div>
          <div className="header-right">
            <button onClick={() => setShowRegulation(true)} className="btn-regulation">
              📄 ระเบียบการ
            </button>
            <span className="user-chip">🎓 {applicant.level} | {applicant.idCard}</span>
            <button className="btn-logout" onClick={onLogout}>ออกจากระบบ</button>
          </div>
        </div>
      </header>
      <div className="main-content">
        <div className="page-title">
          <div>
            <h2>ใบสมัครเรียน {applicant.level} ปีการศึกษา 2569</h2>
            <div className="subtitle">โรงเรียนหล่มสักวิทยาคม อ.หล่มสัก จ.เพชรบูรณ์</div>
          </div>
          <div style={{ marginLeft: "auto" }}><StatusBadge status={status} /></div>
        </div>

        {status === "pending" && <div className="status-banner waiting"><h3>📋 รอการตรวจสอบจากเจ้าหน้าที่</h3><p className="text-sm">ข้อมูลได้รับการบันทึกแล้ว กรุณารอเจ้าหน้าที่ตรวจสอบ</p></div>}
        {status === "approved" && (
          <div className="status-banner approved">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 10 }}>
              <div>
                <h3 style={{ color: "var(--success)" }}>✅ ผ่านการตรวจสอบจากเจ้าหน้าที่</h3>
                <p className="text-sm">การสมัครของท่านได้รับการยืนยันเรียบร้อยแล้ว</p>
                <div className="exam-info">
                  <div className="exam-info-item"><div className="lbl">เลขที่นั่งสอบ</div><div className="val">{examNo || "-"}</div></div>
                  <div className="exam-info-item"><div className="lbl">ห้องสอบ</div><div className="val">{examRoom || "-"}</div></div>
                  {applicant.level === "ม.1" && serviceArea && (
                    <div className="exam-info-item"><div className="lbl">ประเภท</div><div className="val" style={{ fontSize: 15 }}>{serviceArea}</div></div>
                  )}
                </div>
              </div>
              <button
                className="btn btn-primary"
                style={{ flexShrink: 0 }}
                onClick={() => printAdmissionCard({ form, examNo, examRoom, serviceArea, level: applicant.level })}
              >
                🖨️ พิมพ์บัตรประจำตัวผู้สมัคร
              </button>
            </div>
          </div>
        )}
        {status === "rejected" && (
          <div className="status-banner rejected">
            <h3 style={{ color: "var(--danger)" }}>🔄 กรุณาแก้ไขข้อมูล</h3>
            {remark && <p className="text-sm" style={{ marginTop: 4 }}>หมายเหตุ: <strong>{remark}</strong></p>}
            <p className="text-sm mt-2">กรุณาแก้ไขข้อมูลและส่งใหม่อีกครั้ง</p>
          </div>
        )}
        {successMsg && <div className="alert alert-success">✅ {successMsg}</div>}

        <div className="card">
          <div className="card-header"><span>📝</span><h2>แบบฟอร์มใบสมัคร</h2></div>
          <div className="card-body">

            <div className="section-title">ข้อมูลส่วนตัว</div>
            <div className="form-grid">
              <div className="form-group">
                <label>คำนำหน้า <span className="req">*</span></label>
                <select value={form.prefix} onChange={e => set("prefix", e.target.value)} disabled={locked}>
                  <option value="">-- เลือก --</option>
                  {PREFIXES.map(p => <option key={p}>{p}</option>)}
                </select>
                {errors.prefix && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.prefix}</span>}
              </div>
              <div className="form-group" />
              <div className="form-group">
                <label>ชื่อ <span className="req">*</span></label>
                <input value={form.firstName} onChange={e => set("firstName", e.target.value)} placeholder="ชื่อ" disabled={locked} />
                {errors.firstName && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.firstName}</span>}
              </div>
              <div className="form-group">
                <label>นามสกุล <span className="req">*</span></label>
                <input value={form.lastName} onChange={e => set("lastName", e.target.value)} placeholder="นามสกุล" disabled={locked} />
                {errors.lastName && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.lastName}</span>}
              </div>
              <div className="form-group">
                <label>วัน เดือน ปี เกิด <span className="req">*</span></label>
                <ThaiDatePicker value={form.birthDate} onChange={val => set("birthDate", val)} disabled={locked} />
                {errors.birthDate && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.birthDate}</span>}
              </div>
              <div className="form-group">
                <label>ศาสนา <span className="req">*</span></label>
                <select value={form.religion} onChange={e => set("religion", e.target.value)} disabled={locked}>
                  <option value="">-- เลือก --</option>
                  {RELIGIONS.map(r => <option key={r}>{r}</option>)}
                </select>
                {errors.religion && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.religion}</span>}
              </div>
              <div className="form-group">
                <label>เลขประจำตัวประชาชน</label>
                <input value={form.idCard} disabled />
              </div>
              <div className="form-group">
                <label>กลุ่มเลือด <span className="req">*</span></label>
                <select value={form.bloodGroup} onChange={e => set("bloodGroup", e.target.value)} disabled={locked}>
                  <option value="">-- เลือก --</option>
                  {BLOOD_GROUPS.map(b => <option key={b}>{b}</option>)}
                </select>
                {errors.bloodGroup && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.bloodGroup}</span>}
              </div>
            </div>

            <hr className="divider" />
            <div className="section-title">ที่อยู่ตามทะเบียนบ้าน</div>
            <div className="form-grid cols-3">
              <div className="form-group">
                <label>บ้านเลขที่ <span className="req">*</span></label>
                <input value={form.houseNo} onChange={e => set("houseNo", e.target.value)} disabled={locked} />
                {errors.houseNo && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.houseNo}</span>}
              </div>
              <div className="form-group">
                <label>หมู่</label>
                <input value={form.moo} onChange={e => set("moo", e.target.value)} disabled={locked} />
              </div>
              <div className="form-group">
                <label>ถนน</label>
                <input value={form.road} onChange={e => set("road", e.target.value)} disabled={locked} />
              </div>
              <div className="form-group">
                <label>ตำบล <span className="req">*</span></label>
                <input value={form.subdistrict} onChange={e => set("subdistrict", e.target.value)} disabled={locked} />
                {errors.subdistrict && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.subdistrict}</span>}
              </div>
              <div className="form-group">
                <label>อำเภอ <span className="req">*</span></label>
                <input value={form.district} onChange={e => set("district", e.target.value)} disabled={locked} />
                {errors.district && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.district}</span>}
              </div>
              <div className="form-group">
                <label>จังหวัด <span className="req">*</span></label>
                <input value={form.province} onChange={e => set("province", e.target.value)} disabled={locked} />
                {errors.province && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.province}</span>}
              </div>
              <div className="form-group">
                <label>รหัสไปรษณีย์</label>
                <input value={form.postalCode} onChange={e => set("postalCode", e.target.value)} maxLength={5} disabled={locked} />
              </div>
              <div className="form-group span-2">
                <label>หมายเลขโทรศัพท์ <span className="req">*</span></label>
                <input value={form.phone} onChange={e => set("phone", e.target.value)} placeholder="0XX-XXX-XXXX" disabled={locked} />
                {errors.phone && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.phone}</span>}
              </div>
            </div>

            <hr className="divider" />
            <div className="section-title">ข้อมูลการศึกษา</div>
            <div className="form-grid">
              <div className="form-group span-2">
                <label>กำลังศึกษา/จบการศึกษาจากโรงเรียน <span className="req">*</span></label>
                <input value={form.fromSchool} onChange={e => set("fromSchool", e.target.value)} disabled={locked} />
                {errors.fromSchool && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.fromSchool}</span>}
              </div>
              {isM4 && (
                <div className="form-group">
                  <label>เกรดเฉลี่ย 5 ภาคเรียน <span className="req">*</span></label>
                  <input value={form.gpa} onChange={e => set("gpa", e.target.value)} placeholder="0.00" disabled={locked} />
                  {errors.gpa && <span style={{ color: "var(--danger)", fontSize: 11 }}>{errors.gpa}</span>}
                </div>
              )}
              <div className="form-group">
                <label>ตำบล</label>
                <input value={form.schoolSubdistrict} onChange={e => set("schoolSubdistrict", e.target.value)} disabled={locked} />
              </div>
              <div className="form-group">
                <label>อำเภอ</label>
                <input value={form.schoolDistrict} onChange={e => set("schoolDistrict", e.target.value)} disabled={locked} />
              </div>
              <div className="form-group">
                <label>จังหวัด</label>
                <input value={form.schoolProvince} onChange={e => set("schoolProvince", e.target.value)} disabled={locked} />
              </div>
            </div>

            <hr className="divider" />
            <div className="section-title">ข้อมูลผู้ปกครอง</div>
            <div className="form-grid">
              <div className="form-group"><label>ชื่อ-สกุล บิดา</label><input value={form.fatherName} onChange={e => set("fatherName", e.target.value)} disabled={locked} /></div>
              <div className="form-group"><label>โทรศัพท์ บิดา</label><input value={form.fatherPhone} onChange={e => set("fatherPhone", e.target.value)} disabled={locked} /></div>
              <div className="form-group span-2"><label>อาชีพ บิดา</label><input value={form.fatherOccupation} onChange={e => set("fatherOccupation", e.target.value)} disabled={locked} /></div>
              <div className="form-group"><label>ชื่อ-สกุล มารดา</label><input value={form.motherName} onChange={e => set("motherName", e.target.value)} disabled={locked} /></div>
              <div className="form-group"><label>โทรศัพท์ มารดา</label><input value={form.motherPhone} onChange={e => set("motherPhone", e.target.value)} disabled={locked} /></div>
              <div className="form-group span-2"><label>อาชีพ มารดา</label><input value={form.motherOccupation} onChange={e => set("motherOccupation", e.target.value)} disabled={locked} /></div>
              <div className="form-group"><label>ชื่อ-สกุล ผู้ปกครอง</label><input value={form.guardianName} onChange={e => set("guardianName", e.target.value)} disabled={locked} /></div>
              <div className="form-group"><label>โทรศัพท์ ผู้ปกครอง</label><input value={form.guardianPhone} onChange={e => set("guardianPhone", e.target.value)} disabled={locked} /></div>
              <div className="form-group span-2"><label>อาชีพ ผู้ปกครอง</label><input value={form.guardianOccupation} onChange={e => set("guardianOccupation", e.target.value)} disabled={locked} /></div>
            </div>

            {isM4 && (
              <>
                <hr className="divider" />
                <div className="section-title">ลำดับแผนการเรียนที่ต้องการ</div>
                <div className="alert alert-info" style={{ marginBottom: 14 }}>📌 เลือกตามลำดับความต้องการ (ลำดับ 1 = ต้องการมากที่สุด) ห้ามเลือกซ้ำ เลือกอย่างน้อย 1 ลำดับ</div>
                {errors.plan && <div className="alert alert-danger">{errors.plan}</div>}
                <div className="plan-rows">
                  {[0, 1, 2, 3, 4].map(idx => {
                    const usedPlans = form.planPriority.filter((p, i) => p !== "" && i !== idx);
                    return (
                      <div key={idx} className={`plan-row ${form.planPriority[idx] ? "selected" : ""}`}>
                        <div className="plan-rank">อันดับ {idx + 1}</div>
                        <select value={form.planPriority[idx]} onChange={e => setPlan(idx, e.target.value)} disabled={locked} style={{ minWidth: 240 }}>
                          <option value="">-- ไม่เลือก --</option>
                          {PLANS.map(p => <option key={p} value={p} disabled={usedPlans.includes(p)}>{p}</option>)}
                        </select>
                      </div>
                    );
                  })}
                </div>
              </>
            )}

            <hr className="divider" />
            <div className="section-title">เอกสารประกอบการสมัคร</div>
            <div className="alert alert-warning" style={{ marginBottom: 14 }}>📎 รูปถ่าย: รองรับไฟล์รูปภาพเท่านั้น | เอกสารอื่น: รองรับรูปภาพและ PDF ขนาดไม่เกิน 10 MB</div>
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              {[
                { key: "photo", label: "รูปถ่ายสวมชุดนักเรียนโรงเรียนเดิม ไม่สวมแว่น (ไม่เกิน 6 เดือน)", acceptOnly: "image/*", hint: "รูปภาพเท่านั้น (.jpg, .jpeg, .png) ขนาดไม่เกิน 10 MB" },
                { key: "pp1front", label: doc1Label, acceptOnly: "image/*,.pdf", hint: "ไฟล์รูปภาพ (.jpg, .jpeg, .png) หรือ PDF ขนาดไม่เกิน 10 MB" },
                { key: "pp1back", label: doc2Label, acceptOnly: "image/*,.pdf", hint: "ไฟล์รูปภาพ (.jpg, .jpeg, .png) หรือ PDF ขนาดไม่เกิน 10 MB" },
                { key: "housebook", label: "สำเนาทะเบียนบ้าน", acceptOnly: "image/*,.pdf", hint: "ไฟล์รูปภาพ (.jpg, .jpeg, .png) หรือ PDF ขนาดไม่เกิน 10 MB" },
              ].map(({ key, label, acceptOnly, hint }) => {
                const fileObj = form.docs[key];
                const hasFile = fileObj && fileObj.url;
                const isPdf = fileObj?.name?.toLowerCase().endsWith(".pdf");
                return (
                  <div key={key} className="upload-card">
                    <span className="upload-label">{label}</span>
                    {!locked && (
                      <input type="file" accept={acceptOnly}
                        onChange={e => setDoc(key, e.target.files[0])}
                        disabled={uploadingDoc[key]}
                      />
                    )}
                    {uploadingDoc[key] && (
                      <div style={{ fontSize: 12, color: "var(--primary)", marginTop: 4, display: "flex", alignItems: "center", gap: 6 }}>
                        <span className="spinner" style={{ borderTopColor: "var(--primary)", borderColor: "var(--border)", width: 14, height: 14 }} /> กำลังอัพโหลด...
                      </div>
                    )}
                    {hasFile && !uploadingDoc[key] && (
                      <div style={{ marginTop: 6, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
                        <span className="uploaded-file">✅ {fileObj.name}</span>
                        <DocPreviewButton url={fileObj.url} name={fileObj.name} isPdf={isPdf} />
                      </div>
                    )}
                    {!hasFile && locked && <div className="text-sm text-muted mt-2">ยังไม่ได้อัพโหลด</div>}
                    <div className="upload-hint">{hint}</div>
                  </div>
                );
              })}
            </div>

            {(status === "draft" || status === "rejected") && (
              <div style={{ marginTop: 24, display: "flex", justifyContent: "flex-end" }}>
                <button className="btn btn-accent" onClick={handleSubmit} disabled={saving} style={{ fontSize: 15, padding: "12px 32px" }}>
                  {saving ? <><span className="spinner" /> กำลังส่ง...</> : "📤 ส่งข้อมูลการสมัคร"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* ===== Modal ระเบียบการ ===== */}
      {showRegulation && (
        <div className="modal-bg" style={{ zIndex: 300 }} onClick={e => e.target === e.currentTarget && setShowRegulation(false)}>
          <div className="modal-box" style={{ maxWidth: 900 }}>
            <div className="modal-header">
              <h3>📄 ระเบียบการรับสมัครนักเรียน ปีการศึกษา 2569</h3>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <a
                  href="/regulation.pdf"
                  download="ระเบียบการรับสมัคร.pdf"
                  style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: "white", padding: "5px 12px", borderRadius: 6, fontSize: 12, textDecoration: "none" }}
                >
                  ⬇️ ดาวน์โหลด
                </a>
                <button className="modal-close" onClick={() => setShowRegulation(false)}>×</button>
              </div>
            </div>
            <div style={{ background: "#2a2a3e", padding: 8, minHeight: 500 }}>
              <iframe
                src="/regulation.pdf"
                title="ระเบียบการ"
                style={{ width: "100%", height: "75vh", border: "none", borderRadius: 4, display: "block" }}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ===== ADMIN DOC VIEWER (with file replace) =====
function AdminDocViewer({ docs, idCard, onDocsUpdated }) {
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState({});
  const isPdf = (name) => name && name.toLowerCase().endsWith(".pdf");

  const handleReplace = async (fieldName, acceptOnly, file) => {
    if (!file) return;
    setUploading(u => ({ ...u, [fieldName]: true }));
    try {
      const result = await uploadFile(idCard, fieldName, file);
      const newDocs = { ...docs, [fieldName]: result };
      onDocsUpdated(newDocs);
    } catch (e) { alert(e.message); }
    setUploading(u => ({ ...u, [fieldName]: false }));
  };

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {Object.entries(docs).map(([key, fileObj]) => {
          const label = DOC_LABELS[key] || key;
          const hasFile = fileObj && fileObj.url;
          const acceptOnly = key === "photo" ? "image/*" : "image/*,.pdf";
          return (
            <div key={key} style={{
              padding: "10px 14px", borderRadius: 8,
              background: hasFile ? "#f0faf4" : "#fff8f0",
              border: `1.5px solid ${hasFile ? "#a8d5be" : "#ffd0a0"}`,
            }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 8 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span style={{ fontSize: 18 }}>{hasFile ? (isPdf(fileObj.name) ? "📄" : "🖼️") : "❌"}</span>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600, color: hasFile ? "var(--success)" : "var(--warning)" }}>{label}</div>
                    <div style={{ fontSize: 11, color: "var(--text-muted)" }}>{hasFile ? fileObj.name : "ยังไม่ได้อัพโหลด"}</div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  {hasFile && (
                    <button className="btn btn-outline btn-sm"
                      onClick={() => setPreview({ label, name: fileObj.name, url: fileObj.url })}>
                      👁️ ดู
                    </button>
                  )}
                  <label style={{
                    cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 4,
                    padding: "6px 12px", borderRadius: 7, fontSize: 13, fontWeight: 600,
                    background: "white", border: "1.5px solid var(--border)", color: "var(--text)",
                    transition: "border-color 0.2s",
                  }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = "var(--primary-light)"}
                    onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}
                  >
                    {uploading[key]
                      ? <><span className="spinner" style={{ width: 14, height: 14, borderTopColor: "var(--primary)", borderColor: "var(--border)" }} /> กำลังอัพโหลด...</>
                      : <>{hasFile ? "🔄 เปลี่ยนไฟล์" : "📎 อัพโหลด"}</>
                    }
                    <input type="file" accept={acceptOnly} style={{ display: "none" }}
                      onChange={e => handleReplace(key, acceptOnly, e.target.files[0])}
                      disabled={uploading[key]}
                    />
                  </label>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Preview Modal */}
      {preview && (
        <div className="modal-bg" style={{ zIndex: 400 }} onClick={e => e.target === e.currentTarget && setPreview(null)}>
          <div className="modal-box" style={{ maxWidth: 860 }}>
            <div className="modal-header">
              <h3>📎 {preview.label} — {preview.name}</h3>
              <div style={{ display: "flex", gap: 8 }}>
                <a href={`${preview.url}/download`}
                  style={{ background: "rgba(255,255,255,0.15)", border: "1px solid rgba(255,255,255,0.3)", color: "white", padding: "5px 12px", borderRadius: 6, fontSize: 12, textDecoration: "none" }}>
                  ⬇️ ดาวน์โหลด
                </a>
                <button className="modal-close" onClick={() => setPreview(null)}>×</button>
              </div>
            </div>
            <div style={{ padding: 16, background: "#1a1a2e", minHeight: 400, display: "flex", alignItems: "center", justifyContent: "center" }}>
              {isPdf(preview.name)
                ? <iframe src={preview.url} title={preview.label} style={{ width: "100%", height: "70vh", border: "none", borderRadius: 6 }} />
                : <img src={preview.url} alt={preview.label} style={{ maxWidth: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 6, boxShadow: "0 4px 20px rgba(0,0,0,0.4)" }} />
              }
            </div>
          </div>
        </div>
      )}
    </>
  );
}

// ===== PRINT APPLICATION PDF =====
function printApplicationPDF(app) {
  const f = app.form;
  const docs = f.docs || {};
  const photoUrl = docs.photo?.url || "";
  const isM1 = app.level === "ม.1";

  // แปลงวันเกิดเป็นภาษาไทย
  const thMonths = ["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"];
  const birthThai = (() => {
    if (!f.birthDate) return "-";
    const [y, m, d] = f.birthDate.split("-");
    return `${parseInt(d)} ${thMonths[parseInt(m)-1]} ${parseInt(y)+543}`;
  })();

  const planList = (f.planPriority || []).filter(p => p).map((p, i) => `อันดับ ${i+1}: ${p}`).join("<br>");

  const docItems = [
    { key: "photo", label: "รูปถ่ายสวมชุดนักเรียน" },
    { key: "pp1front", label: isM1 ? "ปพ.1/ปพ.6/ปพ.7 (ด้านหน้า)" : "ปพ.1 (ด้านหน้า)" },
    { key: "pp1back", label: isM1 ? "ปพ.1/ปพ.6/ปพ.7 (ด้านหลัง)" : "ปพ.1 (ด้านหลัง)" },
    { key: "housebook", label: "สำเนาทะเบียนบ้าน" },
  ];

  // สร้าง pages ของหลักฐาน
  const evidencePages = docItems
    .filter(d => docs[d.key]?.url && !docs[d.key].name?.toLowerCase().endsWith(".pdf"))
    .map(d => `
      <div class="evidence-page">
        <div class="evidence-header">${d.label}</div>
        <div class="evidence-body">
          <img src="${docs[d.key].url}" alt="${d.label}" crossorigin="anonymous" />
        </div>
      </div>
    `).join("");

  const pdfEvidenceLinks = docItems
    .filter(d => docs[d.key]?.url && docs[d.key].name?.toLowerCase().endsWith(".pdf"))
    .map(d => `<div class="pdf-note">📄 <strong>${d.label}</strong>: ${docs[d.key].name} (ไฟล์ PDF — กรุณาพิมพ์แยก)</div>`)
    .join("");

  const html = `<!DOCTYPE html>
<html lang="th">
<head>
  <meta charset="UTF-8">
  <title>ใบสมัคร — ${f.prefix}${f.firstName} ${f.lastName}</title>
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Sarabun:wght@300;400;500;600;700&family=Noto+Serif+Thai:wght@600;700;800&display=swap');
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'Sarabun', sans-serif; background: white; color: #1a2233; }

    /* ===== PAGE 1: ใบสมัคร ===== */
    .app-page {
      width: 210mm; min-height: 297mm;
      padding: 14mm 16mm 12mm;
      page-break-after: always;
      position: relative;
    }
    .page-header {
      display: flex; align-items: center; gap: 14px;
      border-bottom: 3px solid #1a3a6b; padding-bottom: 12px; margin-bottom: 14px;
    }
    .page-logo { width: 60px; height: 60px; border-radius: 50%; object-fit: contain; border: 2px solid #1a3a6b; }
    .page-header-text h1 {
      font-family: 'Noto Serif Thai', serif; font-size: 15px; font-weight: 800; line-height: 1.5; color: #1a3a6b;
    }
    .page-header-text p { font-size: 12px; color: #5a6880; margin-top: 2px; }
    .photo-corner {
      position: absolute; top: 14mm; right: 16mm;
      width: 80px; border: 2px solid #d0d8e8; border-radius: 6px;
      overflow: hidden; aspect-ratio: 3/4; background: #f0f4f8;
      display: flex; align-items: center; justify-content: center;
    }
    .photo-corner img { width: 100%; height: 100%; object-fit: cover; }
    .photo-corner-placeholder { font-size: 10px; color: #aaa; text-align: center; padding: 6px; }

    /* sections */
    .section { margin-bottom: 12px; }
    .section-title {
      font-family: 'Noto Serif Thai', serif; font-size: 13px; font-weight: 700;
      color: white; background: #1a3a6b;
      padding: 4px 12px; border-radius: 4px; margin-bottom: 8px; display: inline-block;
    }
    .field-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4px 16px; }
    .field-grid.cols3 { grid-template-columns: 1fr 1fr 1fr; }
    .field { padding: 3px 0; border-bottom: 1px solid #edf0f5; }
    .field-label { font-size: 10px; color: #5a6880; }
    .field-value { font-size: 12.5px; font-weight: 600; color: #1a2233; min-height: 16px; }
    .field.span2 { grid-column: span 2; }

    /* exam box */
    .exam-box {
      margin-top: 12px; border: 2px solid #1a3a6b; border-radius: 8px;
      padding: 10px 16px; display: flex; gap: 24px; flex-wrap: wrap;
      background: #f0f4f8;
    }
    .exam-item .lbl { font-size: 10px; color: #5a6880; text-transform: uppercase; letter-spacing: 0.5px; }
    .exam-item .val { font-size: 22px; font-weight: 800; color: #1a3a6b; }

    .sign-row { margin-top: 14px; display: flex; justify-content: flex-end; gap: 40px; }
    .sign-box { text-align: center; width: 120px; }
    .sign-line { border-top: 1px solid #333; margin-bottom: 4px; padding-top: 4px; font-size: 11px; }

    /* ===== EVIDENCE PAGES ===== */
    .evidence-page {
      width: 210mm; min-height: 297mm;
      padding: 14mm 16mm 12mm;
      page-break-after: always;
      display: flex; flex-direction: column;
    }
    .evidence-header {
      font-family: 'Noto Serif Thai', serif; font-size: 14px; font-weight: 700;
      color: white; background: #1a3a6b;
      padding: 8px 16px; border-radius: 6px; margin-bottom: 14px;
    }
    .evidence-body { flex: 1; display: flex; align-items: center; justify-content: center; }
    .evidence-body img { max-width: 100%; max-height: 240mm; object-fit: contain; border: 1px solid #ddd; border-radius: 6px; }
    .pdf-note { padding: 12px 16px; background: #fff8e6; border: 1px solid #ffd580; border-radius: 6px; margin: 8px 0; font-size: 13px; }

    @media print {
      body { background: white; }
      .app-page, .evidence-page { padding: 10mm 12mm; }
    }
  </style>
</head>
<body>

  <!-- PAGE 1: ใบสมัคร -->
  <div class="app-page">
    <div class="page-header">
      <img class="page-logo" src="https://lomsak.ac.th/schlogo.png" alt="โลโก้" onerror="this.style.display='none'" />
      <div class="page-header-text">
        <h1>ใบสมัครเข้าเรียนชั้นมัธยมศึกษาปีที่ ${isM1 ? "1" : "4"} ปีการศึกษา 2569<br>ประเภทห้องเรียนปกติ โรงเรียนหล่มสักวิทยาคม</h1>
        <p>อำเภอหล่มสัก จังหวัดเพชรบูรณ์ ${app.serviceArea && isM1 ? `&nbsp;|&nbsp; ${app.serviceArea}` : ""}</p>
      </div>
    </div>

    <!-- รูปถ่าย -->
    <div class="photo-corner">
      ${photoUrl
        ? `<img src="${photoUrl}" alt="รูปถ่าย" crossorigin="anonymous" />`
        : `<div class="photo-corner-placeholder">รูปถ่าย</div>`
      }
    </div>

    <!-- ข้อมูลส่วนตัว -->
    <div class="section">
      <div class="section-title">ข้อมูลส่วนตัว</div>
      <div class="field-grid">
        <div class="field span2">
          <div class="field-label">ชื่อ-นามสกุล</div>
          <div class="field-value">${f.prefix}${f.firstName} ${f.lastName}</div>
        </div>
        <div class="field"><div class="field-label">วันเกิด</div><div class="field-value">${birthThai}</div></div>
        <div class="field"><div class="field-label">ศาสนา</div><div class="field-value">${f.religion || "-"}</div></div>
        <div class="field"><div class="field-label">กลุ่มเลือด</div><div class="field-value">${f.bloodGroup || "-"}</div></div>
        <div class="field"><div class="field-label">เลขประจำตัวประชาชน</div><div class="field-value">${f.idCard || "-"}</div></div>
        <div class="field"><div class="field-label">โทรศัพท์</div><div class="field-value">${f.phone || "-"}</div></div>
      </div>
    </div>

    <!-- ที่อยู่ -->
    <div class="section">
      <div class="section-title">ที่อยู่ตามทะเบียนบ้าน</div>
      <div class="field-grid cols3">
        <div class="field span2"><div class="field-label">ที่อยู่</div><div class="field-value">${f.houseNo || "-"} ม.${f.moo || "-"} ถ.${f.road || "-"} ต.${f.subdistrict || "-"} อ.${f.district || "-"} จ.${f.province || "-"} ${f.postalCode || ""}</div></div>
      </div>
    </div>

    <!-- การศึกษา -->
    <div class="section">
      <div class="section-title">ข้อมูลการศึกษา</div>
      <div class="field-grid">
        <div class="field span2"><div class="field-label">โรงเรียนเดิม</div><div class="field-value">${f.fromSchool || "-"} ต.${f.schoolSubdistrict || "-"} อ.${f.schoolDistrict || "-"} จ.${f.schoolProvince || "-"}</div></div>
        ${!isM1 ? `<div class="field"><div class="field-label">เกรดเฉลี่ย 5 ภาคเรียน</div><div class="field-value">${f.gpa || "-"}</div></div>` : ""}
      </div>
      ${!isM1 && planList ? `<div style="margin-top:6px;font-size:12px;"><strong>แผนการเรียน:</strong><br>${planList}</div>` : ""}
    </div>

    <!-- ผู้ปกครอง -->
    <div class="section">
      <div class="section-title">ข้อมูลผู้ปกครอง</div>
      <div class="field-grid cols3">
        <div class="field"><div class="field-label">ชื่อบิดา</div><div class="field-value">${f.fatherName || "-"}</div></div>
        <div class="field"><div class="field-label">โทร.บิดา</div><div class="field-value">${f.fatherPhone || "-"}</div></div>
        <div class="field"><div class="field-label">อาชีพบิดา</div><div class="field-value">${f.fatherOccupation || "-"}</div></div>
        <div class="field"><div class="field-label">ชื่อมารดา</div><div class="field-value">${f.motherName || "-"}</div></div>
        <div class="field"><div class="field-label">โทร.มารดา</div><div class="field-value">${f.motherPhone || "-"}</div></div>
        <div class="field"><div class="field-label">อาชีพมารดา</div><div class="field-value">${f.motherOccupation || "-"}</div></div>
        <div class="field"><div class="field-label">ชื่อผู้ปกครอง</div><div class="field-value">${f.guardianName || "-"}</div></div>
        <div class="field"><div class="field-label">โทร.ผู้ปกครอง</div><div class="field-value">${f.guardianPhone || "-"}</div></div>
        <div class="field"><div class="field-label">อาชีพผู้ปกครอง</div><div class="field-value">${f.guardianOccupation || "-"}</div></div>
      </div>
    </div>

    <!-- กล่องเลขสอบ -->
    ${app.examNo ? `
    <div class="exam-box">
      <div class="exam-item"><div class="lbl">เลขที่นั่งสอบ</div><div class="val">${app.examNo}</div></div>
      <div class="exam-item"><div class="lbl">ห้องสอบ</div><div class="val">${app.examRoom}</div></div>
      ${app.serviceArea && isM1 ? `<div class="exam-item"><div class="lbl">ประเภทนักเรียน</div><div class="val" style="font-size:14px">${app.serviceArea}</div></div>` : ""}
    </div>` : ""}

    <!-- ลายเซ็น -->
    <div class="sign-row">
      <div class="sign-box">
        <div style="height:36px"></div>
        <div class="sign-line">ลายมือชื่อผู้สมัคร</div>
      </div>
      <div class="sign-box">
        <div style="height:36px"></div>
        <div class="sign-line">เจ้าหน้าที่รับสมัคร</div>
      </div>
    </div>
  </div>

  <!-- EVIDENCE PAGES -->
  ${evidencePages}

  ${pdfEvidenceLinks ? `<div class="app-page"><div class="section-title">หมายเหตุ — ไฟล์ PDF</div><div style="margin-top:12px">${pdfEvidenceLinks}</div></div>` : ""}

  <script>
    // รอรูปโหลดเสร็จก่อน print
    window.addEventListener('load', () => {
      const imgs = document.querySelectorAll('img');
      let loaded = 0;
      if (imgs.length === 0) { window.print(); return; }
      imgs.forEach(img => {
        if (img.complete) { loaded++; if (loaded === imgs.length) window.print(); }
        else {
          img.onload = img.onerror = () => { loaded++; if (loaded === imgs.length) window.print(); };
        }
      });
    });
  </script>
</body>
</html>`;

  const win = window.open("", "_blank");
  win.document.write(html);
  win.document.close();
}

// ===== EXPORT BUTTON COMPONENT =====
function ExportButton({ onExport }) {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: "relative" }}>
      <button
        className="btn btn-accent btn-sm"
        onClick={() => setOpen(o => !o)}
        style={{ gap: 6 }}
      >
        📥 Export CSV ▾
      </button>
      {open && (
        <>
          {/* backdrop */}
          <div style={{ position: "fixed", inset: 0, zIndex: 10 }} onClick={() => setOpen(false)} />
          <div style={{
            position: "absolute", right: 0, top: "calc(100% + 6px)", zIndex: 20,
            background: "white", border: "1.5px solid var(--border)", borderRadius: 8,
            boxShadow: "var(--shadow-lg)", minWidth: 200, overflow: "hidden",
          }}>
            {[
              { label: "📋 ทั้งหมด", value: "all" },
              { label: "⏳ รอตรวจสอบ", value: "pending" },
              { label: "✅ ผ่านการตรวจสอบ", value: "approved" },
              { label: "🔄 ส่งกลับแก้ไข", value: "rejected" },
            ].map(opt => (
              <button key={opt.value}
                style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 16px", background: "none", border: "none", cursor: "pointer", fontSize: 13, fontFamily: "'Sarabun', sans-serif", borderBottom: "1px solid var(--border)" }}
                onMouseEnter={e => e.target.style.background = "#f0f4f8"}
                onMouseLeave={e => e.target.style.background = "none"}
                onClick={() => { onExport(opt.value); setOpen(false); }}
              >
                {opt.label}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

// ===== ADMIN EDIT FORM COMPONENT =====
function AdminEditForm({ form, setForm, level }) {
  const isM4 = level === "ม.4";
  const set = (field, val) => setForm(f => ({ ...f, [field]: val }));
  const setPlan = (idx, val) => {
    const arr = [...form.planPriority];
    arr[idx] = val;
    setForm(f => ({ ...f, planPriority: arr }));
  };

  return (
    <div>
      <div className="alert alert-warning" style={{ marginBottom: 14 }}>
        ✏️ กำลังแก้ไขข้อมูล — กด "บันทึกการแก้ไข" เพื่อยืนยัน
      </div>

      <div className="section-title">ข้อมูลส่วนตัว</div>
      <div className="form-grid">
        <div className="form-group">
          <label>คำนำหน้า</label>
          <select value={form.prefix} onChange={e => set("prefix", e.target.value)}>
            <option value="">-- เลือก --</option>
            {PREFIXES.map(p => <option key={p}>{p}</option>)}
          </select>
        </div>
        <div className="form-group" />
        <div className="form-group">
          <label>ชื่อ</label>
          <input value={form.firstName} onChange={e => set("firstName", e.target.value)} />
        </div>
        <div className="form-group">
          <label>นามสกุล</label>
          <input value={form.lastName} onChange={e => set("lastName", e.target.value)} />
        </div>
        <div className="form-group">
          <label>วัน เดือน ปี เกิด</label>
          <ThaiDatePicker value={form.birthDate} onChange={val => set("birthDate", val)} />
        </div>
        <div className="form-group">
          <label>ศาสนา</label>
          <select value={form.religion} onChange={e => set("religion", e.target.value)}>
            <option value="">-- เลือก --</option>
            {RELIGIONS.map(r => <option key={r}>{r}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>เลขประจำตัวประชาชน</label>
          <input value={form.idCard} disabled />
        </div>
        <div className="form-group">
          <label>กลุ่มเลือด</label>
          <select value={form.bloodGroup} onChange={e => set("bloodGroup", e.target.value)}>
            <option value="">-- เลือก --</option>
            {BLOOD_GROUPS.map(b => <option key={b}>{b}</option>)}
          </select>
        </div>
      </div>

      <hr className="divider" />
      <div className="section-title">ที่อยู่ตามทะเบียนบ้าน</div>
      <div className="form-grid cols-3">
        <div className="form-group"><label>บ้านเลขที่</label><input value={form.houseNo} onChange={e => set("houseNo", e.target.value)} /></div>
        <div className="form-group"><label>หมู่</label><input value={form.moo} onChange={e => set("moo", e.target.value)} /></div>
        <div className="form-group"><label>ถนน</label><input value={form.road} onChange={e => set("road", e.target.value)} /></div>
        <div className="form-group"><label>ตำบล</label><input value={form.subdistrict} onChange={e => set("subdistrict", e.target.value)} /></div>
        <div className="form-group"><label>อำเภอ</label><input value={form.district} onChange={e => set("district", e.target.value)} /></div>
        <div className="form-group"><label>จังหวัด</label><input value={form.province} onChange={e => set("province", e.target.value)} /></div>
        <div className="form-group"><label>รหัสไปรษณีย์</label><input value={form.postalCode} onChange={e => set("postalCode", e.target.value)} maxLength={5} /></div>
        <div className="form-group span-2"><label>โทรศัพท์</label><input value={form.phone} onChange={e => set("phone", e.target.value)} /></div>
      </div>

      <hr className="divider" />
      <div className="section-title">ข้อมูลการศึกษา</div>
      <div className="form-grid">
        <div className="form-group span-2"><label>โรงเรียน</label><input value={form.fromSchool} onChange={e => set("fromSchool", e.target.value)} /></div>
        {isM4 && <div className="form-group"><label>เกรดเฉลี่ย 5 ภาคเรียน</label><input value={form.gpa} onChange={e => set("gpa", e.target.value)} /></div>}
        <div className="form-group"><label>ตำบล</label><input value={form.schoolSubdistrict} onChange={e => set("schoolSubdistrict", e.target.value)} /></div>
        <div className="form-group"><label>อำเภอ</label><input value={form.schoolDistrict} onChange={e => set("schoolDistrict", e.target.value)} /></div>
        <div className="form-group"><label>จังหวัด</label><input value={form.schoolProvince} onChange={e => set("schoolProvince", e.target.value)} /></div>
      </div>

      <hr className="divider" />
      <div className="section-title">ข้อมูลผู้ปกครอง</div>
      <div className="form-grid">
        <div className="form-group"><label>ชื่อ-สกุล บิดา</label><input value={form.fatherName} onChange={e => set("fatherName", e.target.value)} /></div>
        <div className="form-group"><label>โทรศัพท์ บิดา</label><input value={form.fatherPhone} onChange={e => set("fatherPhone", e.target.value)} /></div>
        <div className="form-group span-2"><label>อาชีพ บิดา</label><input value={form.fatherOccupation || ""} onChange={e => set("fatherOccupation", e.target.value)} /></div>
        <div className="form-group"><label>ชื่อ-สกุล มารดา</label><input value={form.motherName} onChange={e => set("motherName", e.target.value)} /></div>
        <div className="form-group"><label>โทรศัพท์ มารดา</label><input value={form.motherPhone} onChange={e => set("motherPhone", e.target.value)} /></div>
        <div className="form-group span-2"><label>อาชีพ มารดา</label><input value={form.motherOccupation || ""} onChange={e => set("motherOccupation", e.target.value)} /></div>
        <div className="form-group"><label>ชื่อ-สกุล ผู้ปกครอง</label><input value={form.guardianName} onChange={e => set("guardianName", e.target.value)} /></div>
        <div className="form-group"><label>โทรศัพท์ ผู้ปกครอง</label><input value={form.guardianPhone} onChange={e => set("guardianPhone", e.target.value)} /></div>
        <div className="form-group span-2"><label>อาชีพ ผู้ปกครอง</label><input value={form.guardianOccupation || ""} onChange={e => set("guardianOccupation", e.target.value)} /></div>
      </div>

      {isM4 && (
        <>
          <hr className="divider" />
          <div className="section-title">ลำดับแผนการเรียน</div>
          <div className="plan-rows">
            {[0, 1, 2, 3, 4].map(idx => {
              const usedPlans = form.planPriority.filter((p, i) => p !== "" && i !== idx);
              return (
                <div key={idx} className={`plan-row ${form.planPriority[idx] ? "selected" : ""}`}>
                  <div className="plan-rank">อันดับ {idx + 1}</div>
                  <select value={form.planPriority[idx]} onChange={e => setPlan(idx, e.target.value)} style={{ minWidth: 240 }}>
                    <option value="">-- ไม่เลือก --</option>
                    {PLANS.map(p => <option key={p} value={p} disabled={usedPlans.includes(p)}>{p}</option>)}
                  </select>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

// ===== ADMIN PANEL =====
function AdminPanel({ user, onLogout }) {
  const [tab, setTab] = useState("applications");
  const [applicants, setApplicants] = useState([]);
  const [applications, setApplications] = useState([]);
  const [newIdCard, setNewIdCard] = useState("");
  const [newLevel, setNewLevel] = useState("ม.1");
  const [addMsg, setAddMsg] = useState("");
  const [viewApp, setViewApp] = useState(null);
  const [confirmModal, setConfirmModal] = useState(null);
  const [examNo, setExamNo] = useState("");
  const [examRoom, setExamRoom] = useState("");
  const [serviceArea, setServiceArea] = useState("นักเรียนในเขตพื้นที่บริการ");
  const [rejectRemark, setRejectRemark] = useState("");
  const [filterLevel, setFilterLevel] = useState("ทั้งหมด");
  const [filterStatus, setFilterStatus] = useState("ทั้งหมด");
  const [loadingData, setLoadingData] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [editApp, setEditApp] = useState(null); // form ที่กำลังแก้ไข

  // silent refresh — ไม่แสดง loading spinner เมื่อเป็นการ refresh อัตโนมัติ
  const fetchAll = useCallback(async (silent = false) => {
    if (!silent) setLoadingData(true);
    try {
      const [apps, appls] = await Promise.all([
        apiFetch("/applicants"),
        apiFetch("/applications"),
      ]);
      setApplicants(apps);
      setApplications(appls);
      setLastUpdated(new Date());
    } catch (e) { console.error(e); }
    if (!silent) setLoadingData(false);
  }, []);

  // โหลดครั้งแรก + auto-refresh ทุก 30 วินาที
  useEffect(() => {
    fetchAll();
    const interval = setInterval(() => fetchAll(true), 30000);
    return () => clearInterval(interval);
  }, [fetchAll]);

  // Export CSV
  const exportCSV = (statusFilter = "all") => {
    const rows = applications.filter(a => statusFilter === "all" || a.status === statusFilter);
    if (rows.length === 0) { alert("ไม่มีข้อมูลที่จะ export"); return; }

    const headers = [
      "เลขประชาชน", "ระดับชั้น", "สถานะ",
      "คำนำหน้า", "ชื่อ", "นามสกุล", "วันเกิด", "ศาสนา", "กลุ่มเลือด",
      "บ้านเลขที่", "หมู่", "ตำบล", "ถนน", "อำเภอ", "จังหวัด", "รหัสไปรษณีย์", "โทรศัพท์",
      "โรงเรียนเดิม", "เกรดเฉลี่ย", "ต.โรงเรียน", "อ.โรงเรียน", "จ.โรงเรียน",
      "ชื่อบิดา", "โทรบิดา", "อาชีพบิดา", "ชื่อมารดา", "โทรมารดา", "อาชีพมารดา", "ชื่อผู้ปกครอง", "โทรผู้ปกครอง", "อาชีพผู้ปกครอง",
      "แผน อันดับ1", "แผน อันดับ2", "แผน อันดับ3", "แผน อันดับ4", "แผน อันดับ5",
      "เลขที่นั่งสอบ", "ห้องสอบ", "ประเภทนักเรียน (ม.1)", "วันที่ส่ง",
    ];

    const escape = (val) => {
      const str = val == null ? "" : String(val);
      return str.includes(",") || str.includes('"') || str.includes("\n")
        ? `"${str.replace(/"/g, '""')}"` : str;
    };

    const csvRows = rows.map(a => {
      const f = a.form;
      const statusTh = { draft: "ยังไม่ส่ง", pending: "รอตรวจสอบ", approved: "ผ่านการตรวจสอบ", rejected: "ส่งกลับแก้ไข" }[a.status] || a.status;
      return [
        a.idCard, a.level, statusTh,
        f.prefix, f.firstName, f.lastName, (() => { const p = isoToParts(f.birthDate); return p.day && p.month && p.year ? `${p.day} ${THAI_MONTHS[parseInt(p.month)-1]} ${p.year}` : f.birthDate || ""; })(), f.religion, f.bloodGroup,
        f.houseNo, f.moo, f.subdistrict, f.road, f.district, f.province, f.postalCode, f.phone,
        f.fromSchool, f.gpa || "", f.schoolSubdistrict, f.schoolDistrict, f.schoolProvince,
        f.fatherName, f.fatherPhone, f.fatherOccupation || "", f.motherName, f.motherPhone, f.motherOccupation || "", f.guardianName, f.guardianPhone, f.guardianOccupation || "",
        ...(f.planPriority || ["", "", "", "", ""]),
        a.examNo || "", a.examRoom || "",
        a.level === "ม.1" ? (a.serviceArea || "") : "",
        a.submittedAt ? new Date(a.submittedAt).toLocaleDateString("th-TH") : "",
      ].map(escape).join(",");
    });

    const bom = "\uFEFF"; // BOM สำหรับ Excel ภาษาไทย
    const csv = bom + [headers.join(","), ...csvRows].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    const label = statusFilter === "all" ? "ทั้งหมด" : { pending: "รอตรวจสอบ", approved: "ผ่านการตรวจสอบ", rejected: "ส่งกลับแก้ไข" }[statusFilter];
    a.download = `ผู้สมัคร_${label}_${new Date().toLocaleDateString("th-TH").replace(/\//g, "-")}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleAddApplicant = async () => {
    setAddMsg("");
    try {
      await apiFetch("/applicants", { method: "POST", body: { idCard: newIdCard.trim(), level: newLevel } });
      setNewIdCard("");
      setAddMsg("✅ เพิ่มผู้สมัครสำเร็จ");
      fetchAll();
    } catch (e) { setAddMsg("❌ " + e.message); }
  };

  const handleApprove = async () => {
    setActionLoading(true);
    try {
      const body = { examNo, examRoom };
      if (confirmModal.level === "ม.1") body.serviceArea = serviceArea;
      await apiFetch(`/applications/${confirmModal.idCard}/approve`, { method: "PATCH", body });
      setConfirmModal(null); setExamNo(""); setExamRoom("");
      setServiceArea("นักเรียนในเขตพื้นที่บริการ");
      fetchAll();
    } catch (e) { alert(e.message); }
    setActionLoading(false);
  };

  const handleReject = async () => {
    setActionLoading(true);
    try {
      await apiFetch(`/applications/${viewApp.idCard}/reject`, {
        method: "PATCH", body: { remark: rejectRemark },
      });
      setViewApp(null); setRejectRemark("");
      fetchAll();
    } catch (e) { alert(e.message); }
    setActionLoading(false);
  };

  const handleSaveEdit = async () => {
    setActionLoading(true);
    try {
      await apiFetch(`/applications/${viewApp.idCard}/edit`, {
        method: "PATCH", body: { form: editApp },
      });
      // อัพเดท viewApp ให้แสดงข้อมูลใหม่ทันที
      setViewApp(prev => ({ ...prev, form: editApp }));
      setEditApp(null);
      fetchAll(true);
      alert("✅ บันทึกข้อมูลเรียบร้อยแล้ว");
    } catch (e) { alert("เกิดข้อผิดพลาด: " + e.message); }
    setActionLoading(false);
  };

  const filtered = applications.filter(a => {
    const lvlOk = filterLevel === "ทั้งหมด" || a.level === filterLevel;
    const stOk = filterStatus === "ทั้งหมด" || a.status === filterStatus;
    return lvlOk && stOk;
  });

  const stats = {
    total: applicants.length,
    pending: applications.filter(a => a.status === "pending").length,
    approved: applications.filter(a => a.status === "approved").length,
    rejected: applications.filter(a => a.status === "rejected").length,
  };

  return (
    <div className="app-wrap">
      <style>{globalStyle}</style>
      <header className="site-header">
        <div className="header-inner">
          <div className="school-logo">ห</div>
          <div className="school-title"><h1>โรงเรียนหล่มสักวิทยาคม</h1><p>แผงควบคุมเจ้าหน้าที่ — ปีการศึกษา 2569</p></div>
          <div className="header-right">
            <span className="user-chip">🔐 {user.data.username}</span>
            <button className="btn-logout" onClick={onLogout}>ออกจากระบบ</button>
          </div>
        </div>
      </header>
      <div className="main-content" style={{ maxWidth: 1100 }}>
        {/* Stats */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 10, marginBottom: 18 }} className="stats-grid">
          {[
            { label: "ผู้สมัครทั้งหมด", val: stats.total, color: "var(--primary)" },
            { label: "รอตรวจสอบ", val: stats.pending, color: "var(--warning)" },
            { label: "ผ่านการตรวจสอบ", val: stats.approved, color: "var(--success)" },
            { label: "ส่งกลับแก้ไข", val: stats.rejected, color: "var(--danger)" },
          ].map(s => (
            <div key={s.label} className="card" style={{ padding: "14px 18px" }}>
              <div style={{ fontSize: 28, fontWeight: 700, color: s.color }}>{s.val}</div>
              <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 2 }}>{s.label}</div>
            </div>
          ))}
        </div>

        <div className="card">
          <div className="card-body" style={{ paddingBottom: 0 }}>
            <div className="admin-nav">
              <button className={`admin-nav-btn ${tab === "applications" ? "active" : ""}`} onClick={() => setTab("applications")}>📋 ตรวจข้อมูล ({applications.length})</button>
              <button className={`admin-nav-btn ${tab === "add" ? "active" : ""}`} onClick={() => setTab("add")}>➕ เพิ่มผู้สมัคร</button>
              <button className={`admin-nav-btn ${tab === "list" ? "active" : ""}`} onClick={() => setTab("list")}>👥 รายชื่อทั้งหมด ({applicants.length})</button>
            </div>
          </div>

          {/* Tab: Applications */}
          {tab === "applications" && (
            <div className="card-body">
              <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap", alignItems: "flex-end" }}>
                <div className="form-group" style={{ minWidth: 140 }}>
                  <label>ระดับชั้น</label>
                  <select value={filterLevel} onChange={e => setFilterLevel(e.target.value)}>
                    <option>ทั้งหมด</option><option>ม.1</option><option>ม.4</option>
                  </select>
                </div>
                <div className="form-group" style={{ minWidth: 160 }}>
                  <label>สถานะ</label>
                  <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                    <option>ทั้งหมด</option>
                    <option value="pending">รอตรวจสอบ</option>
                    <option value="approved">ผ่านการตรวจสอบ</option>
                    <option value="rejected">ส่งกลับแก้ไข</option>
                  </select>
                </div>
                <button className="btn btn-outline btn-sm" onClick={() => fetchAll(false)}>🔄 รีเฟรชตอนนี้</button>
                {/* Export CSV */}
                <div style={{ position: "relative", marginLeft: "auto" }}>
                  <ExportButton onExport={exportCSV} />
                </div>
              </div>
              {lastUpdated && (
                <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 10 }}>
                  🕐 อัพเดทล่าสุด: {lastUpdated.toLocaleTimeString("th-TH")} (อัตโนมัติทุก 30 วินาที)
                </div>
              )}
              {loadingData ? (
                <div style={{ textAlign: "center", padding: 30, color: "var(--text-muted)" }}><div style={{ margin: "0 auto 10px", width: 32, height: 32, border: "3px solid var(--border)", borderTopColor: "var(--primary)", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} /><p>กำลังโหลด...</p></div>
              ) : filtered.length === 0 ? (
                <div className="alert alert-info">ยังไม่มีข้อมูลการสมัคร</div>
              ) : (
                <div className="table-wrap">
                  <table>
                    <thead><tr><th>เลขประชาชน</th><th>ชื่อ-สกุล</th><th>ชั้น</th><th>วันที่ส่ง</th><th>สถานะ</th><th>จัดการ</th></tr></thead>
                    <tbody>
                      {filtered.map(app => (
                        <tr key={app.idCard}>
                          <td style={{ fontFamily: "monospace" }}>{app.idCard}</td>
                          <td>{app.form.prefix}{app.form.firstName} {app.form.lastName}</td>
                          <td><span className="badge badge-review">{app.level}</span></td>
                          <td className="text-sm text-muted">{app.submittedAt ? new Date(app.submittedAt).toLocaleDateString("th-TH") : "-"}</td>
                          <td><StatusBadge status={app.status} /></td>
                          <td><button className="btn btn-outline btn-sm" onClick={() => { setViewApp(app); setRejectRemark(app.remark || ""); }}>🔍 ดูข้อมูล</button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* Tab: Add */}
          {tab === "add" && (
            <div className="card-body">
              <div className="page-title"><div><h2>เพิ่มผู้สมัครเข้าระบบ</h2><div className="subtitle">เพิ่มเลขประจำตัวประชาชนและระดับชั้น</div></div></div>
              {addMsg && <div className={`alert ${addMsg.startsWith("✅") ? "alert-success" : "alert-danger"}`}>{addMsg}</div>}
              <div className="form-grid" style={{ maxWidth: 500 }}>
                <div className="form-group span-2">
                  <label>เลขประจำตัวประชาชน (13 หลัก) <span className="req">*</span></label>
                  <input value={newIdCard} onChange={e => setNewIdCard(e.target.value)} placeholder="X-XXXX-XXXXX-XX-X" maxLength={13} />
                </div>
                <div className="form-group">
                  <label>ระดับชั้น <span className="req">*</span></label>
                  <select value={newLevel} onChange={e => setNewLevel(e.target.value)}><option>ม.1</option><option>ม.4</option></select>
                </div>
                <div className="form-group" style={{ justifyContent: "flex-end" }}>
                  <label style={{ opacity: 0 }}>.</label>
                  <button className="btn btn-primary" onClick={handleAddApplicant}>➕ เพิ่มผู้สมัคร</button>
                </div>
              </div>
            </div>
          )}

          {/* Tab: List */}
          {tab === "list" && (
            <div className="card-body">
              <div className="page-title"><div><h2>รายชื่อผู้สมัครทั้งหมด</h2></div><button className="btn btn-outline btn-sm" onClick={fetchAll}>🔄 รีเฟรช</button></div>
              {applicants.length === 0 ? <div className="alert alert-info">ยังไม่มีผู้สมัครในระบบ</div> : (
                <div className="table-wrap">
                  <table>
                    <thead><tr><th>#</th><th>เลขประจำตัวประชาชน</th><th>ระดับชั้น</th><th>สถานะ</th><th>วันที่เพิ่ม</th></tr></thead>
                    <tbody>
                      {applicants.map((a, i) => {
                        const app = applications.find(ap => ap.idCard === a.idCard);
                        return (
                          <tr key={a.idCard}>
                            <td className="text-muted">{i + 1}</td>
                            <td style={{ fontFamily: "monospace" }}>{a.idCard}</td>
                            <td>{a.level}</td>
                            <td><StatusBadge status={app ? app.status : "draft"} /></td>
                            <td className="text-sm text-muted">{a.createdAt ? new Date(a.createdAt).toLocaleDateString("th-TH") : "-"}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* View / Edit Modal */}
      {viewApp && (
        <div className="modal-bg" onClick={e => e.target === e.currentTarget && !editApp && setViewApp(null)}>
          <div className="modal-box">
            <div className="modal-header">
              <h3>{editApp ? "✏️ แก้ไขใบสมัคร" : "📋 ใบสมัคร"} — {viewApp.idCard}</h3>
              <button className="modal-close" onClick={() => { setViewApp(null); setEditApp(null); }}>×</button>
            </div>
            <div className="modal-body">
              <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14, flexWrap: "wrap" }}>
                <StatusBadge status={viewApp.status} />
                <span className="badge badge-review">{viewApp.level}</span>
                {!editApp && (
                  <button className="btn btn-outline btn-sm" style={{ marginLeft: "auto" }}
                    onClick={() => setEditApp(JSON.parse(JSON.stringify(viewApp.form)))}>
                    ✏️ แก้ไขข้อมูล
                  </button>
                )}
              </div>

              {editApp ? (
                /* ===== โหมดแก้ไข ===== */
                <AdminEditForm
                  form={editApp}
                  setForm={setEditApp}
                  level={viewApp.level}
                />
              ) : (
                /* ===== โหมดดู ===== */
                <>
                  <div className="section-title">ข้อมูลส่วนตัว</div>
                  <div className="info-grid">
                    <div className="info-row"><span className="info-label">ชื่อ-สกุล</span><span className="info-value">{viewApp.form.prefix}{viewApp.form.firstName} {viewApp.form.lastName}</span></div>
                    <div className="info-row"><span className="info-label">วันเกิด</span><span className="info-value">{(() => { const p = isoToParts(viewApp.form.birthDate); return p.day && p.month && p.year ? `${p.day} ${THAI_MONTHS[parseInt(p.month)-1]} ${p.year}` : viewApp.form.birthDate || "-"; })()}</span></div>
                    <div className="info-row"><span className="info-label">ศาสนา</span><span className="info-value">{viewApp.form.religion}</span></div>
                    <div className="info-row"><span className="info-label">กลุ่มเลือด</span><span className="info-value">{viewApp.form.bloodGroup}</span></div>
                  </div>
                  <div className="section-title">ที่อยู่</div>
                  <div className="info-grid">
                    <div className="info-row"><span className="info-label">ที่อยู่</span><span className="info-value">{viewApp.form.houseNo} ม.{viewApp.form.moo} ต.{viewApp.form.subdistrict} อ.{viewApp.form.district} จ.{viewApp.form.province} {viewApp.form.postalCode}</span></div>
                    <div className="info-row"><span className="info-label">โทรศัพท์</span><span className="info-value">{viewApp.form.phone}</span></div>
                  </div>
                  <div className="section-title">การศึกษา</div>
                  <div className="info-grid">
                    <div className="info-row"><span className="info-label">โรงเรียนเดิม</span><span className="info-value">{viewApp.form.fromSchool}</span></div>
                    {viewApp.level === "ม.4" && <div className="info-row"><span className="info-label">เกรดเฉลี่ย</span><span className="info-value">{viewApp.form.gpa}</span></div>}
                  </div>
                  <div className="section-title">ผู้ปกครอง</div>
                  <div className="info-grid">
                    <div className="info-row"><span className="info-label">บิดา</span><span className="info-value">{viewApp.form.fatherName || "-"} {viewApp.form.fatherPhone && `(${viewApp.form.fatherPhone})`}{viewApp.form.fatherOccupation && ` — ${viewApp.form.fatherOccupation}`}</span></div>
                    <div className="info-row"><span className="info-label">มารดา</span><span className="info-value">{viewApp.form.motherName || "-"} {viewApp.form.motherPhone && `(${viewApp.form.motherPhone})`}{viewApp.form.motherOccupation && ` — ${viewApp.form.motherOccupation}`}</span></div>
                    <div className="info-row"><span className="info-label">ผู้ปกครอง</span><span className="info-value">{viewApp.form.guardianName || "-"} {viewApp.form.guardianPhone && `(${viewApp.form.guardianPhone})`}{viewApp.form.guardianOccupation && ` — ${viewApp.form.guardianOccupation}`}</span></div>
                  </div>
                  {viewApp.level === "ม.4" && viewApp.form.planPriority.some(p => p) && (
                    <>
                      <div className="section-title">แผนการเรียน</div>
                      {viewApp.form.planPriority.map((p, i) => p ? <div key={i} style={{ fontSize: 13, padding: "3px 0" }}><span className="text-muted">อันดับ {i + 1}:</span> <strong>{p}</strong></div> : null)}
                    </>
                  )}
                  <div className="section-title">เอกสารแนบ</div>
                  <AdminDocViewer
                    docs={viewApp.form.docs}
                    idCard={viewApp.idCard}
                    onDocsUpdated={(newDocs) => {
                      setViewApp(prev => ({ ...prev, form: { ...prev.form, docs: newDocs } }));
                      fetchAll(true);
                    }}
                  />
                  {viewApp.status === "approved" && (
                    <>
                      <hr className="divider" />
                      <div className="info-grid">
                        <div className="info-row"><span className="info-label">เลขที่นั่งสอบ</span><span className="info-value" style={{ fontSize: 20, color: "var(--primary)", fontWeight: 700 }}>{viewApp.examNo}</span></div>
                        <div className="info-row"><span className="info-label">ห้องสอบ</span><span className="info-value" style={{ fontSize: 20, color: "var(--primary)", fontWeight: 700 }}>{viewApp.examRoom}</span></div>
                        {viewApp.level === "ม.1" && viewApp.serviceArea && (
                          <div className="info-row"><span className="info-label">ประเภทนักเรียน</span><span className="info-value">{viewApp.serviceArea}</span></div>
                        )}
                      </div>
                    </>
                  )}
                  {viewApp.status === "pending" && (
                    <>
                      <hr className="divider" />
                      <div className="form-group">
                        <label>หมายเหตุสำหรับส่งกลับแก้ไข</label>
                        <input value={rejectRemark} onChange={e => setRejectRemark(e.target.value)} placeholder="ระบุส่วนที่ต้องแก้ไข..." />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
            <div className="modal-footer">
              {editApp ? (
                <>
                  <button className="btn btn-outline" onClick={() => setEditApp(null)}>ยกเลิก</button>
                  <button className="btn btn-primary" onClick={handleSaveEdit} disabled={actionLoading}>
                    {actionLoading ? <span className="spinner" /> : "💾 บันทึกการแก้ไข"}
                  </button>
                </>
              ) : (
                <>
                  <button className="btn btn-outline" onClick={() => setViewApp(null)}>ปิด</button>
                  <button className="btn btn-outline btn-sm"
                    onClick={() => printApplicationPDF(viewApp)}
                    title="พิมพ์ใบสมัคร + หลักฐาน">
                    🖨️ พิมพ์ใบสมัคร
                  </button>
                  {viewApp.status === "pending" && (
                    <>
                      <button className="btn btn-danger btn-sm" onClick={handleReject} disabled={actionLoading}>🔄 ส่งกลับแก้ไข</button>
                      <button className="btn btn-success btn-sm" onClick={() => { setConfirmModal(viewApp); setViewApp(null); }} disabled={actionLoading}>✅ ยืนยันข้อมูล</button>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Confirm Modal */}
      {confirmModal && (
        <div className="modal-bg">
          <div className="modal-box" style={{ maxWidth: 440 }}>
            <div className="modal-header"><h3>✅ ยืนยันการสมัคร</h3><button className="modal-close" onClick={() => setConfirmModal(null)}>×</button></div>
            <div className="modal-body">
              <div className="alert alert-success" style={{ marginBottom: 16 }}>
                ยืนยันข้อมูลของ: <strong>{confirmModal.form.prefix}{confirmModal.form.firstName} {confirmModal.form.lastName}</strong>
                <span className="badge badge-review" style={{ marginLeft: 8 }}>{confirmModal.level}</span>
              </div>
              <div className="form-group" style={{ marginBottom: 12 }}>
                <label>เลขที่นั่งสอบ <span className="req">*</span></label>
                <input value={examNo} onChange={e => setExamNo(e.target.value)} placeholder="เช่น 001, A001" />
              </div>
              <div className="form-group" style={{ marginBottom: 12 }}>
                <label>ห้องสอบ <span className="req">*</span></label>
                <input value={examRoom} onChange={e => setExamRoom(e.target.value)} placeholder="เช่น ห้อง 101" />
              </div>
              {confirmModal.level === "ม.1" && (
                <div className="form-group">
                  <label>ประเภทนักเรียน <span className="req">*</span></label>
                  <select value={serviceArea} onChange={e => setServiceArea(e.target.value)}>
                    <option value="นักเรียนในเขตพื้นที่บริการ">นักเรียนในเขตพื้นที่บริการ</option>
                    <option value="นักเรียนนอกเขตพื้นที่บริการ">นักเรียนนอกเขตพื้นที่บริการ</option>
                  </select>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-outline" onClick={() => setConfirmModal(null)}>ยกเลิก</button>
              <button className="btn btn-success" onClick={handleApprove}
                disabled={!examNo || !examRoom || actionLoading}>
                {actionLoading ? <span className="spinner" /> : "✅ ยืนยันและแจ้งผู้สมัคร"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ===== APP ROOT =====
export default function App() {
  // โหลด session จาก sessionStorage ถ้ามี (ป้องกันหลุด login ตอน refresh)
  const [session, setSession] = useState(() => {
    try {
      const saved = sessionStorage.getItem("lomsak_session");
      return saved ? JSON.parse(saved) : null;
    } catch { return null; }
  });

  const handleLogin = (s) => {
    sessionStorage.setItem("lomsak_session", JSON.stringify(s));
    setSession(s);
  };

  const handleLogout = () => {
    sessionStorage.removeItem("lomsak_session");
    setSession(null);
  };

  return (
    <>
      <style>{globalStyle}</style>
      {!session && <LoginPage onLogin={handleLogin} />}
      {session?.role === "applicant" && <ApplicationForm user={session} onLogout={handleLogout} />}
      {session?.role === "admin" && <AdminPanel user={session} onLogout={handleLogout} />}
    </>
  );
}
